if (function(t) {
        var e = 0,
            i = "scrollIntoView" in document.createElement("li");
        t.fn.awesomecomplete = function(o) {
            var o = t.extend({}, t.fn.awesomecomplete.defaults, o);
            return this.each(function() {
                var r = t(this),
                    s = t.meta ? t.extend({}, o, r.data()) : o;
                r.data("awesomecomplete-config", s);
                var a = t(s.attachTo || r),
                    l = t("<ul/>");
                s.wrapSuggestions ? l.appendTo(a) : l.insertAfter(a), l.hide().addClass(s.suggestionListClass).css("width", a.innerWidth()), r.data("awesomecomplete-list", l);
                var c, u = !1;
                r.keyup(function(t) {
                    return u ? void(u = !1) : void(t.which > 36 && t.which < 41 || 16 == t.which || (s.typingDelay > 0 ? (clearTimeout(c), c = setTimeout(function() {
                        n(r)
                    }, s.typingDelay)) : n(r)))
                }), r.keydown(function(t) {
                    var e = l.children("li." + s.activeItemClass);
                    switch (t.which) {
                        case 13:
                            0 !== e.length && l.is(":visible") && (t.preventDefault(), r.val(e.data("awesomecomplete-value")), s.onComplete(e.data("awesomecomplete-dataItem")), l.hide()), l.hide(), u = !0;
                            break;
                        case 38:
                            t.preventDefault(), 0 === e.length ? l.children("li:last-child").addClass(s.activeItemClass) : (e.prev().addClass(s.activeItemClass), e.removeClass(s.activeItemClass));
                            break;
                        case 40:
                            t.preventDefault(), 0 === e.length ? l.children("li:first-child").addClass(s.activeItemClass) : e.is(":not(:last-child)") && (e.next().addClass(s.activeItemClass), e.removeClass(s.activeItemClass));
                            break;
                        case 27:
                            l.hide(), u = !0
                    }
                    if (i && l.is(":visible")) {
                        var e = l.children("li." + s.activeItemClass);
                        e.length > 0 && e.get(0).scrollIntoView(!1)
                    }
                }), r.keypress(function(t) {
                    l.children("li." + s.activeItemClass);
                    13 == t.which && l.children("li." + s.activeItemClass).length > 0 && t.preventDefault()
                });
                var d = !1,
                    p = !1;
                t(document).bind("mousedown.awesomecomplete" + ++e, function() {
                    d = !0
                }), t(document).bind("mouseup.awesomecomplete" + e, function() {
                    d = !1, p && (p = !1, l.hide())
                }), r.blur(function() {
                    if (d) p = !0;
                    else {
                        var t = l.children("li." + s.activeItemClass);
                        l.is(":visible") && 0 !== t.length && r.val(t.data("awesomecomplete-value")), l.hide()
                    }
                }), r.focus(function() {
                    l.children(":not(." + s.noResultsClass + ")").length > 0 && l.show()
                })
            })
        };
        var o = function(e, i) {
                return function(o) {
                    t(".autocomplete__spinner").hide(), r(e, o, i)
                }
            },
            n = function(e) {
                var i = e.val();
                t(".autocomplete__spinner").show(), e.data("awesomecomplete-list").hide(), "function" == typeof e.data("awesomecomplete-config").dataMethod ? e.data("awesomecomplete-config").dataMethod(i, e, o(e, i)) : r(e, e.data("awesomecomplete-config").staticData, i)
            },
            r = function(e, i, o) {
                var n = e.data("awesomecomplete-list");
                if (n.empty().hide(), "" !== o) {
                    for (var r = e.data("awesomecomplete-config"), s = [], a = 0; a < i.length; a++) {
                        var l = jQuery.extend({}, i[a]);
                        s.push({
                            dataItem: l,
                            originalDataItem: i[a]
                        })
                    }
                    s.sort(function(t, e) {
                        return r.sortFunction(t, e, o)
                    }), s = s.slice(0, r.resultLimit);
                    for (var c in s) t('<li class="' + r.itemClass + '">' + r.renderFunction(s[c].dataItem, o, s[c].topMatch, s[c].originalDataItem, r) + "</li>").data("awesomecomplete-dataItem", s[c].originalDataItem).data("awesomecomplete-value", r.valueFunction(s[c].originalDataItem, r)).appendTo(n).click(function() {
                        var i = t(this);
                        e.val(i.data("awesomecomplete-value")), r.onComplete(i.data("awesomecomplete-dataItem"))
                    }).mouseover(function() {
                        t(this).addClass(r.activeItemClass).siblings().removeClass(r.activeItemClass)
                    });
                    void 0 !== r.noResultsMessage && 0 == s.length && n.append(t('<li class="' + r.noResultsClass + '">' + r.noResultsMessage + "</li>")), (s.length > 0 || void 0 !== r.noResultsMessage) && n.show()
                }
            },
            s = function(t, e, i, o) {
                return e === o.nameField || null === e ? '<p class="title">' + t[o.nameField] + "</p>" : '<p class="title">' + t[o.nameField] + '</p><p class="matchRow"><span class="matchedField">' + e + "</span>: " + t[e] + "</p>"
            },
            a = function(t, e) {
                return t[e.nameField]
            },
            l = function(t, e, i) {
                return t.matchedTermCount == e.matchedTermCount ? e.matchCount - t.matchCount : e.matchedTermCount - t.matchedTermCount
            };
        t.fn.awesomecomplete.defaults = {
            activeItemClass: "active",
            itemClass: "item",
            attachTo: void 0,
            wrapSuggestions: !1,
            dataMethod: void 0,
            dontMatch: [],
            highlightMatches: !0,
            highlightClass: "match",
            ignoreCase: !0,
            nameField: "name",
            noResultsClass: "noResults",
            noResultsMessage: void 0,
            onComplete: function(t) {},
            sortFunction: l,
            splitTerm: !0,
            staticData: [],
            suggestionListClass: "autocomplete",
            renderFunction: s,
            resultLimit: 10,
            typingDelay: 0,
            valueFunction: a,
            wordDelimiter: /[^\da-z]+/gi
        }
    }(jQuery), function(t, e) {
        "function" == typeof define && define.amd ? define([], function() {
            return t.returnExportsGlobal = e()
        }) : "object" == typeof exports ? module.exports = e() : t.bouncefix = e()
    }(this, function() {
        var t;
        t = function() {
            function t(t, e, i, o) {
                this.el = t, this.eventName = e, this.handler = i, this.context = o, this.add()
            }
            return t.prototype._handler = function(t, e) {
                var i = {};
                for (var o in t) i[o] = t[o];
                i.stopPropagation = function() {
                    t.stopPropagation ? t.stopPropagation() : t.cancelBubble = !0
                }, i.preventDefault = function() {
                    t.preventDefault ? t.preventDefault() : t.returnValue = !1
                }, this.handler.call(this.context || e, i)
            }, t.prototype.add = function() {
                var t = this;
                t.cachedHandler = function(e) {
                    t._handler.call(t, e, this)
                }, t.el.addEventListener(t.eventName, t.cachedHandler, !1)
            }, t.prototype.remove = function() {
                this.el.removeEventListener(this.eventName, this.cachedHandler)
            }, t
        }();
        var e;
        e = function() {
            var t = {};
            return t.getTargetedEl = function(t, e) {
                for (;;) {
                    if (t.classList.contains(e)) break;
                    if (!(t = t.parentElement)) break
                }
                return t
            }, t.isScrollable = function(t) {
                return t.scrollHeight > t.offsetHeight
            }, t.scrollToEnd = function(t) {
                var e = t.scrollTop,
                    i = t.offsetHeight,
                    o = t.scrollHeight;
                0 >= e && (t.scrollTop = 1), e + i >= o && (t.scrollTop = o - i - 1)
            }, t
        }();
        var i;
        i = function(t, e) {
            var i = function(e) {
                if (!(this instanceof i)) return new i(e);
                if (!e) throw new Error('"className" argument is required');
                this.className = e, this.startListener = new t(document, "touchstart", this.touchStart, this), this.endListener = new t(document, "touchend", this.touchEnd, this)
            };
            return i.prototype.touchStart = function(i) {
                var o = e.getTargetedEl(i.target, this.className);
                return o && e.isScrollable(o) ? e.scrollToEnd(o) : void(o && !this.moveListener && (this.moveListener = new t(o, "touchmove", this.touchMove, this)))
            }, i.prototype.touchMove = function(t) {
                t.preventDefault()
            }, i.prototype.touchEnd = function(t) {
                this.moveListener && (this.moveListener.remove(), delete this.moveListener)
            }, i.prototype.remove = function() {
                this.startListener.remove(), this.endListener.remove()
            }, i
        }(t, e);
        var o;
        return o = function(t) {
            var e = {
                cache: {}
            };
            return e.add = function(e) {
                this.cache[e] || (this.cache[e] = new t(e))
            }, e.remove = function(t) {
                this.cache[t] && (this.cache[t].remove(), delete this.cache[t])
            }, e
        }(i)
    }), function(t) {
        "use strict";
        t.fn.bPopup = function(e, i) {
            function o() {
                f(_.onOpen), z = (O.data("bPopup") || 0) + 1, b = N + z + "__", C = "auto" !== _.position[1], T = "auto" !== _.position[0], S = "fixed" === _.positionStyle, I = P.outerHeight(!0), E = P.outerWidth(!0), _.loadUrl ? n() : r()
            }

            function n() {
                switch (_.contentContainer = t(_.contentContainer || P), _.content) {
                    case "iframe":
                        var e = t('<iframe class="b-iframe" ' + _.iframeAttr + "></iframe>");
                        e.appendTo(_.contentContainer), I = P.outerHeight(!0), E = P.outerWidth(!0), r(), e.attr("src", _.loadUrl), f(_.loadCallback);
                        break;
                    case "image":
                        r(), t("<img />").load(function() {
                            f(_.loadCallback), l(t(this))
                        }).attr("src", _.loadUrl).hide().appendTo(_.contentContainer);
                        break;
                    default:
                        r(), t('<div class="b-ajax-wrapper"></div>').load(_.loadUrl, _.loadData, function(e, i, o) {
                            f(_.loadCallback, i), l(t(this))
                        }).hide().appendTo(_.contentContainer)
                }
            }

            function r() {
                _.modal && t('<div class="b-modal ' + b + '"></div>').css({
                    backgroundColor: _.modalColor,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    opacity: 0,
                    zIndex: _.zIndex + z
                }).appendTo(_.appendTo).fadeTo(_.speed, _.opacity), y(), P.data("bPopup", _).data("id", b).css({
                    left: "slideIn" == _.transition || "slideBack" == _.transition ? "slideBack" == _.transition ? M.scrollLeft() + R : -1 * (x + E) : h(!(!_.follow[0] && T || S)),
                    position: _.positionStyle || "absolute",
                    top: "slideDown" == _.transition || "slideUp" == _.transition ? "slideUp" == _.transition ? M.scrollTop() + j : $ + -1 * I : m(!(!_.follow[1] && C || S)),
                    "z-index": _.zIndex + z + 1
                }).each(function() {
                    _.appending && t(this).appendTo(_.appendTo)
                }), d(!0)
            }

            function s() {
                return _.modal && t(".b-modal." + P.data("id")).fadeTo(_.speed, 0, function() {
                    t(this).remove()
                }), u(), clearTimeout(L), d(), !1
            }

            function a(e) {
                j = v(), R = w(), k = g(), (k.x || k.y) && (clearTimeout(A), A = setTimeout(function() {
                    y(), e = e || _.followSpeed;
                    var i = {};
                    k.x && (i.left = _.follow[0] ? h(!0) : "auto"), k.y && (i.top = _.follow[1] ? m(!0) : "auto"), P.dequeue().each(function() {
                        S ? t(this).css({
                            left: x,
                            top: $
                        }) : t(this).animate(i, e, _.followEasing)
                    })
                }, 50))
            }

            function l(t) {
                var e = t.width(),
                    i = t.height(),
                    o = {};
                _.contentContainer.css({
                    height: i,
                    width: e
                }), i >= P.height() && (o.height = P.height()), e >= P.width() && (o.width = P.width()), I = P.outerHeight(!0), E = P.outerWidth(!0), y(), _.contentContainer.css({
                    height: "auto",
                    width: "auto"
                }), o.left = h(!(!_.follow[0] && T || S)), o.top = m(!(!_.follow[1] && C || S)), P.animate(o, 250, function() {
                    t.show(), k = g()
                })
            }

            function c() {
                O.data("bPopup", z), P.delegate(".bClose, ." + _.closeClass, "click." + b, s), _.modalClose && t(".b-modal." + b).css("cursor", "pointer").bind("click", s), B || !_.follow[0] && !_.follow[1] || O.bind("scroll." + b, function() {
                    if (k.x || k.y) {
                        var t = {};
                        k.x && (t.left = _.follow[0] ? h(!S) : "auto"), k.y && (t.top = _.follow[1] ? m(!S) : "auto"), P.dequeue().animate(t, _.followSpeed, _.followEasing)
                    }
                }).bind("resize." + b, function() {
                    a()
                }), _.escClose && M.bind("keydown." + b, function(t) {
                    27 == t.which && s()
                })
            }

            function u() {
                _.scrollBar || t("html").css("overflow", "auto"), t(".b-modal." + b).unbind("click"), M.unbind("keydown." + b), O.unbind("." + b).data("bPopup", O.data("bPopup") - 1 > 0 ? O.data("bPopup") - 1 : null), P.undelegate(".bClose, ." + _.closeClass, "click." + b, s).data("bPopup", null)
            }

            function d(t) {
                function e(e) {
                    P.css({
                        display: "block",
                        opacity: 1
                    }).animate(e, _.speed, _.easing, function() {
                        p(t)
                    })
                }
                switch (t ? _.transition : _.transitionClose || _.transition) {
                    case "slideIn":
                        e({
                            left: t ? h(!(!_.follow[0] && T || S)) : M.scrollLeft() - (E || P.outerWidth(!0)) - H
                        });
                        break;
                    case "slideBack":
                        e({
                            left: t ? h(!(!_.follow[0] && T || S)) : M.scrollLeft() + R + H
                        });
                        break;
                    case "slideDown":
                        e({
                            top: t ? m(!(!_.follow[1] && C || S)) : M.scrollTop() - (I || P.outerHeight(!0)) - H
                        });
                        break;
                    case "slideUp":
                        e({
                            top: t ? m(!(!_.follow[1] && C || S)) : M.scrollTop() + j + H
                        });
                        break;
                    default:
                        P.stop().fadeTo(_.speed, t ? 1 : 0, function() {
                            p(t)
                        })
                }
            }

            function p(t) {
                t ? (c(), f(i), _.autoClose && (L = setTimeout(s, _.autoClose))) : (P.hide(), f(_.onClose), _.loadUrl && (_.contentContainer.empty(), P.css({
                    height: "auto",
                    width: "auto"
                })))
            }

            function h(t) {
                return t ? x + M.scrollLeft() : x
            }

            function m(t) {
                return t ? $ + M.scrollTop() : $
            }

            function f(e, i) {
                t.isFunction(e) && e.call(P, i)
            }

            function y() {
                $ = C ? _.position[1] : Math.max(0, (j - P.outerHeight(!0)) / 2 - _.amsl), x = T ? _.position[0] : (R - P.outerWidth(!0)) / 2, k = g()
            }

            function g() {
                return {
                    x: R > P.outerWidth(!0),
                    y: j > P.outerHeight(!0)
                }
            }

            function v() {
                return O.height()
            }

            function w() {
                return O.width()
            }
            t.isFunction(e) && (i = e, e = null);
            var _ = t.extend({}, t.fn.bPopup.defaults, e);
            _.scrollBar || t("html").css("overflow", "hidden");
            var b, k, C, T, S, $, x, I, E, A, L, P = this,
                M = t(document),
                D = window,
                O = t(D),
                j = v(),
                R = w(),
                N = "__b-popup",
                B = /OS 6(_\d)+/i.test(navigator.userAgent),
                H = 200,
                z = 0;
            return P.close = function() {
                s()
            }, P.reposition = function(t) {
                a(t)
            }, P.each(function() {
                t(this).data("bPopup") || o()
            })
        }, t.fn.bPopup.defaults = {
            amsl: 50,
            appending: !0,
            appendTo: "body",
            autoClose: !1,
            closeClass: "b-close",
            content: "ajax",
            contentContainer: !1,
            easing: "swing",
            escClose: !0,
            follow: [!0, !0],
            followEasing: "swing",
            followSpeed: 500,
            iframeAttr: 'scrolling="no" frameborder="0"',
            loadCallback: !1,
            loadData: !1,
            loadUrl: !1,
            modal: !0,
            modalClose: !0,
            modalColor: "#000",
            onClose: !1,
            onOpen: !1,
            opacity: .7,
            position: ["auto", "auto"],
            positionStyle: "absolute",
            scrollBar: !0,
            speed: 250,
            transition: "fadeIn",
            transitionClose: !1,
            zIndex: 9997
        }
    }(jQuery), function(t) {
        "function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : jQuery)
    }(function(t) {
        function e(t) {
            return a.raw ? t : encodeURIComponent(t)
        }

        function i(t) {
            return a.raw ? t : decodeURIComponent(t)
        }

        function o(t) {
            return e(a.json ? JSON.stringify(t) : String(t))
        }

        function n(t) {
            0 === t.indexOf('"') && (t = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
                return t = decodeURIComponent(t.replace(s, " ")), a.json ? JSON.parse(t) : t
            } catch (e) {}
        }

        function r(e, i) {
            var o = a.raw ? e : n(e);
            return t.isFunction(i) ? i(o) : o
        }
        var s = /\+/g,
            a = t.cookie = function(n, s, l) {
                if (arguments.length > 1 && !t.isFunction(s)) {
                    if (l = t.extend({}, a.defaults, l), "number" == typeof l.expires) {
                        var c = l.expires,
                            u = l.expires = new Date;
                        u.setTime(+u + 864e5 * c)
                    }
                    return document.cookie = [e(n), "=", o(s), l.expires ? "; expires=" + l.expires.toUTCString() : "", l.path ? "; path=" + l.path : "", l.domain ? "; domain=" + l.domain : "", l.secure ? "; secure" : ""].join("")
                }
                for (var d = n ? void 0 : {}, p = document.cookie ? document.cookie.split("; ") : [], h = 0, m = p.length; m > h; h++) {
                    var f = p[h].split("="),
                        y = i(f.shift()),
                        g = f.join("=");
                    if (n && n === y) {
                        d = r(g, s);
                        break
                    }
                    n || void 0 === (g = r(g)) || (d[y] = g)
                }
                return d
            };
        a.defaults = {}, t.removeCookie = function(e, i) {
            return void 0 === t.cookie(e) ? !1 : (t.cookie(e, "", t.extend({}, i, {
                expires: -1
            })), !t.cookie(e))
        }
    }), "undefined" == typeof Currency) var Currency = {};
Currency.cookie = {
        configuration: {
            expires: 365,
            path: "/",
            domain: window.location.hostname
        },
        name: "currency",
        write: function(t) {
            jQuery.cookie(this.name, t, this.configuration)
        },
        read: function() {
            return jQuery.cookie(this.name)
        },
        destroy: function() {
            jQuery.cookie(this.name, null, this.configuration)
        }
    }, Currency.moneyFormats = {
        USD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} USD"
        },
        EUR: {
            money_format: "&euro;{{amount}}",
            money_with_currency_format: "&euro;{{amount}} EUR"
        },
        GBP: {
            money_format: "&pound;{{amount}}",
            money_with_currency_format: "&pound;{{amount}} GBP"
        },
        CAD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} CAD"
        },
        ALL: {
            money_format: "Lek {{amount}}",
            money_with_currency_format: "Lek {{amount}} ALL"
        },
        DZD: {
            money_format: "DA {{amount}}",
            money_with_currency_format: "DA {{amount}} DZD"
        },
        AOA: {
            money_format: "Kz{{amount}}",
            money_with_currency_format: "Kz{{amount}} AOA"
        },
        ARS: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} ARS"
        },
        AMD: {
            money_format: "{{amount}} AMD",
            money_with_currency_format: "{{amount}} AMD"
        },
        AWG: {
            money_format: "Afl{{amount}}",
            money_with_currency_format: "Afl{{amount}} AWG"
        },
        AUD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} AUD"
        },
        BBD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} Bds"
        },
        AZN: {
            money_format: "m.{{amount}}",
            money_with_currency_format: "m.{{amount}} AZN"
        },
        BDT: {
            money_format: "Tk {{amount}}",
            money_with_currency_format: "Tk {{amount}} BDT"
        },
        BSD: {
            money_format: "BS${{amount}}",
            money_with_currency_format: "BS${{amount}} BSD"
        },
        BHD: {
            money_format: "{{amount}}0 BD",
            money_with_currency_format: "{{amount}}0 BHD"
        },
        BYR: {
            money_format: "Br {{amount}}",
            money_with_currency_format: "Br {{amount}} BYR"
        },
        BZD: {
            money_format: "BZ${{amount}}",
            money_with_currency_format: "BZ${{amount}} BZD"
        },
        BTN: {
            money_format: "Nu {{amount}}",
            money_with_currency_format: "Nu {{amount}} BTN"
        },
        BAM: {
            money_format: "KM {{amount_with_comma_separator}}",
            money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
        },
        BRL: {
            money_format: "R$ {{amount_with_comma_separator}}",
            money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
        },
        BOB: {
            money_format: "Bs{{amount_with_comma_separator}}",
            money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
        },
        BWP: {
            money_format: "P{{amount}}",
            money_with_currency_format: "P{{amount}} BWP"
        },
        BND: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} BND"
        },
        BGN: {
            money_format: "{{amount}} ÃÂ»ÃÂ²",
            money_with_currency_format: "{{amount}} ÃÂ»ÃÂ² BGN"
        },
        MMK: {
            money_format: "K{{amount}}",
            money_with_currency_format: "K{{amount}} MMK"
        },
        KHR: {
            money_format: "KHR{{amount}}",
            money_with_currency_format: "KHR{{amount}}"
        },
        KYD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} KYD"
        },
        XAF: {
            money_format: "FCFA{{amount}}",
            money_with_currency_format: "FCFA{{amount}} XAF"
        },
        CLP: {
            money_format: "${{amount_no_decimals}}",
            money_with_currency_format: "${{amount_no_decimals}} CLP"
        },
        CNY: {
            money_format: "&#165;{{amount}}",
            money_with_currency_format: "&#165;{{amount}} CNY"
        },
        COP: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} COP"
        },
        CRC: {
            money_format: "&#8353; {{amount_with_comma_separator}}",
            money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
        },
        HRK: {
            money_format: "{{amount_with_comma_separator}} kn",
            money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
        },
        CZK: {
            money_format: "{{amount_with_comma_separator}} K&#269;",
            money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
        },
        DKK: {
            money_format: "{{amount_with_comma_separator}}",
            money_with_currency_format: "kr.{{amount_with_comma_separator}}"
        },
        DOP: {
            money_format: "RD$ {{amount}}",
            money_with_currency_format: "RD$ {{amount}}"
        },
        XCD: {
            money_format: "${{amount}}",
            money_with_currency_format: "EC${{amount}}"
        },
        EGP: {
            money_format: "LE {{amount}}",
            money_with_currency_format: "LE {{amount}} EGP"
        },
        ETB: {
            money_format: "Br{{amount}}",
            money_with_currency_format: "Br{{amount}} ETB"
        },
        XPF: {
            money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
            money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
        },
        FJD: {
            money_format: "${{amount}}",
            money_with_currency_format: "FJ${{amount}}"
        },
        GMD: {
            money_format: "D {{amount}}",
            money_with_currency_format: "D {{amount}} GMD"
        },
        GHS: {
            money_format: "GH&#8373;{{amount}}",
            money_with_currency_format: "GH&#8373;{{amount}}"
        },
        GTQ: {
            money_format: "Q{{amount}}",
            money_with_currency_format: "{{amount}} GTQ"
        },
        GYD: {
            money_format: "G${{amount}}",
            money_with_currency_format: "${{amount}} GYD"
        },
        GEL: {
            money_format: "{{amount}} GEL",
            money_with_currency_format: "{{amount}} GEL"
        },
        HNL: {
            money_format: "L {{amount}}",
            money_with_currency_format: "L {{amount}} HNL"
        },
        HKD: {
            money_format: "${{amount}}",
            money_with_currency_format: "HK${{amount}}"
        },
        HUF: {
            money_format: "{{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
        },
        ISK: {
            money_format: "{{amount_no_decimals}} kr",
            money_with_currency_format: "{{amount_no_decimals}} kr ISK"
        },
        INR: {
            money_format: "Rs. {{amount}}",
            money_with_currency_format: "Rs. {{amount}}"
        },
        IDR: {
            money_format: "{{amount_with_comma_separator}}",
            money_with_currency_format: "Rp {{amount_with_comma_separator}}"
        },
        ILS: {
            money_format: "{{amount}} NIS",
            money_with_currency_format: "{{amount}} NIS"
        },
        JMD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} JMD"
        },
        JPY: {
            money_format: "&#165;{{amount_no_decimals}}",
            money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
        },
        JEP: {
            money_format: "&pound;{{amount}}",
            money_with_currency_format: "&pound;{{amount}} JEP"
        },
        JOD: {
            money_format: "{{amount}}0 JD",
            money_with_currency_format: "{{amount}}0 JOD"
        },
        KZT: {
            money_format: "{{amount}} KZT",
            money_with_currency_format: "{{amount}} KZT"
        },
        KES: {
            money_format: "KSh{{amount}}",
            money_with_currency_format: "KSh{{amount}}"
        },
        KWD: {
            money_format: "{{amount}}0 KD",
            money_with_currency_format: "{{amount}}0 KWD"
        },
        KGS: {
            money_format: "ÃÂ»ÃÂ²{{amount}}",
            money_with_currency_format: "ÃÂ»ÃÂ²{{amount}}"
        },
        LVL: {
            money_format: "Ls {{amount}}",
            money_with_currency_format: "Ls {{amount}} LVL"
        },
        LBP: {
            money_format: "L&pound;{{amount}}",
            money_with_currency_format: "L&pound;{{amount}} LBP"
        },
        LTL: {
            money_format: "{{amount}} Lt",
            money_with_currency_format: "{{amount}} Lt"
        },
        MGA: {
            money_format: "Ar {{amount}}",
            money_with_currency_format: "Ar {{amount}} MGA"
        },
        MKD: {
            money_format: "ÃÂ´ÃÂµÃÂ½ {{amount}}",
            money_with_currency_format: "ÃÂ´ÃÂµÃÂ½ {{amount}} MKD"
        },
        MOP: {
            money_format: "MOP${{amount}}",
            money_with_currency_format: "MOP${{amount}}"
        },
        MVR: {
            money_format: "Rf{{amount}}",
            money_with_currency_format: "Rf{{amount}} MRf"
        },
        MXN: {
            money_format: "$ {{amount}}",
            money_with_currency_format: "$ {{amount}} MXN"
        },
        MYR: {
            money_format: "RM{{amount}} MYR",
            money_with_currency_format: "RM{{amount}} MYR"
        },
        MUR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} MUR"
        },
        MDL: {
            money_format: "{{amount}} MDL",
            money_with_currency_format: "{{amount}} MDL"
        },
        MAD: {
            money_format: "{{amount}} dh",
            money_with_currency_format: "Dh {{amount}} MAD"
        },
        MNT: {
            money_format: "{{amount_no_decimals}} &#8366",
            money_with_currency_format: "{{amount_no_decimals}} MNT"
        },
        MZN: {
            money_format: "{{amount}} Mt",
            money_with_currency_format: "Mt {{amount}} MZN"
        },
        NAD: {
            money_format: "N${{amount}}",
            money_with_currency_format: "N${{amount}} NAD"
        },
        NPR: {
            money_format: "Rs{{amount}}",
            money_with_currency_format: "Rs{{amount}} NPR"
        },
        ANG: {
            money_format: "&fnof;{{amount}}",
            money_with_currency_format: "{{amount}} NA&fnof;"
        },
        NZD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} NZD"
        },
        NIO: {
            money_format: "C${{amount}}",
            money_with_currency_format: "C${{amount}} NIO"
        },
        NGN: {
            money_format: "&#8358;{{amount}}",
            money_with_currency_format: "&#8358;{{amount}} NGN"
        },
        NOK: {
            money_format: "kr {{amount_with_comma_separator}}",
            money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
        },
        OMR: {
            money_format: "{{amount_with_comma_separator}} OMR",
            money_with_currency_format: "{{amount_with_comma_separator}} OMR"
        },
        PKR: {
            money_format: "Rs.{{amount}}",
            money_with_currency_format: "Rs.{{amount}} PKR"
        },
        PGK: {
            money_format: "K {{amount}}",
            money_with_currency_format: "K {{amount}} PGK"
        },
        PYG: {
            money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
        },
        PEN: {
            money_format: "S/. {{amount}}",
            money_with_currency_format: "S/. {{amount}} PEN"
        },
        PHP: {
            money_format: "&#8369;{{amount}}",
            money_with_currency_format: "&#8369;{{amount}} PHP"
        },
        PLN: {
            money_format: "{{amount_with_comma_separator}} zl",
            money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
        },
        QAR: {
            money_format: "QAR {{amount_with_comma_separator}}",
            money_with_currency_format: "QAR {{amount_with_comma_separator}}"
        },
        RON: {
            money_format: "{{amount_with_comma_separator}} lei",
            money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
        },
        RUB: {
            money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
            money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
        },
        RWF: {
            money_format: "{{amount_no_decimals}} RF",
            money_with_currency_format: "{{amount_no_decimals}} RWF"
        },
        WST: {
            money_format: "WS$ {{amount}}",
            money_with_currency_format: "WS$ {{amount}} WST"
        },
        SAR: {
            money_format: "{{amount}} SR",
            money_with_currency_format: "{{amount}} SAR"
        },
        STD: {
            money_format: "Db {{amount}}",
            money_with_currency_format: "Db {{amount}} STD"
        },
        RSD: {
            money_format: "{{amount}} RSD",
            money_with_currency_format: "{{amount}} RSD"
        },
        SCR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} SCR"
        },
        SGD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} SGD"
        },
        SYP: {
            money_format: "S&pound;{{amount}}",
            money_with_currency_format: "S&pound;{{amount}} SYP"
        },
        ZAR: {
            money_format: "R {{amount}}",
            money_with_currency_format: "R {{amount}} ZAR"
        },
        KRW: {
            money_format: "&#8361;{{amount_no_decimals}}",
            money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
        },
        LKR: {
            money_format: "Rs {{amount}}",
            money_with_currency_format: "Rs {{amount}} LKR"
        },
        SEK: {
            money_format: "{{amount_no_decimals}} kr",
            money_with_currency_format: "{{amount_no_decimals}} kr SEK"
        },
        CHF: {
            money_format: "SFr. {{amount}}",
            money_with_currency_format: "SFr. {{amount}} CHF"
        },
        TWD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} TWD"
        },
        THB: {
            money_format: "{{amount}} &#xe3f;",
            money_with_currency_format: "{{amount}} &#xe3f; THB"
        },
        TZS: {
            money_format: "{{amount}} TZS",
            money_with_currency_format: "{{amount}} TZS"
        },
        TTD: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}} TTD"
        },
        TND: {
            money_format: "{{amount}}",
            money_with_currency_format: "{{amount}} DT"
        },
        TRY: {
            money_format: "{{amount}}TL",
            money_with_currency_format: "{{amount}}TL"
        },
        UGX: {
            money_format: "Ush {{amount_no_decimals}}",
            money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
        },
        UAH: {
            money_format: "Ã¢â€šÂ´{{amount}}",
            money_with_currency_format: "Ã¢â€šÂ´{{amount}} UAH"
        },
        AED: {
            money_format: "Dhs. {{amount}}",
            money_with_currency_format: "Dhs. {{amount}} AED"
        },
        UYU: {
            money_format: "${{amount_with_comma_separator}}",
            money_with_currency_format: "${{amount_with_comma_separator}} UYU"
        },
        VUV: {
            money_format: "${{amount}}",
            money_with_currency_format: "${{amount}}VT"
        },
        VEF: {
            money_format: "Bs. {{amount_with_comma_separator}}",
            money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
        },
        VND: {
            money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
            money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
        },
        XBT: {
            money_format: "{{amount_no_decimals}} BTC",
            money_with_currency_format: "{{amount_no_decimals}} BTC"
        },
        XOF: {
            money_format: "CFA{{amount}}",
            money_with_currency_format: "CFA{{amount}} XOF"
        },
        ZMW: {
            money_format: "K{{amount_no_decimals_with_comma_separator}}",
            money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
        }
    }, Currency.formatMoney = function(t, e) {
        function i(t, e) {
            return "undefined" == typeof t ? e : t
        }

        function o(t, e, o, n) {
            if (e = i(e, 2), o = i(o, ","), n = i(n, "."), isNaN(t) || null == t) return 0;
            t = (t / 100).toFixed(e);
            var r = t.split("."),
                s = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o),
                a = r[1] ? n + r[1] : "";
            return s + a
        }
        if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(t, e);
        "string" == typeof t && (t = t.replace(".", ""));
        var n = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            s = e || "${{amount}}";
        switch (s.match(r)[1]) {
            case "amount":
                n = o(t, 2);
                break;
            case "amount_no_decimals":
                n = o(t, 0);
                break;
            case "amount_with_comma_separator":
                n = o(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = o(t, 0, ".", ",")
        }
        return s.replace(r, n)
    }, Currency.currentCurrency = "", Currency.format = "money_with_currency_format", Currency.convertAll = function(t, e, i, o) {
        t = t || Currency.currentCurrency, e = e || $(".currency-selector__select").val(), jQuery(i || "[data-money-convertible]").each(function() {
            if (jQuery(this).attr("data-currency") !== e) {
                if (jQuery(this).attr("data-currency-" + e)) jQuery(this).html(jQuery(this).attr("data-currency-" + e));
                else {
                    var i = 0,
                        n = Currency.moneyFormats[t][o || Currency.format] || "{{amount}}",
                        r = Currency.moneyFormats[e][o || Currency.format] || "{{amount}}";
                    i = -1 !== n.indexOf("amount_no_decimals") ? Currency.convert(100 * parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10), t, e) : "JOD" === t || "KWD" == t || "BHD" == t ? Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10) / 10, t, e) : Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10), t, e);
                    var s = Currency.formatMoney(i, r);
                    jQuery(this).html(s), jQuery(this).attr("data-currency-" + e, s)
                }
                jQuery(this).attr("data-currency", e)
            }
        }), this.currentCurrency = e, this.cookie.write(e)
    },
    function() {
        "use strict";

        function t(e, o) {
            function n(t, e) {
                return function() {
                    return t.apply(e, arguments)
                }
            }
            var r;
            if (o = o || {}, this.trackingClick = !1, this.trackingClickStart = 0, this.targetElement = null, this.touchStartX = 0, this.touchStartY = 0, this.lastTouchIdentifier = 0, this.touchBoundary = o.touchBoundary || 10, this.layer = e, this.tapDelay = o.tapDelay || 200, this.tapTimeout = o.tapTimeout || 700, !t.notNeeded(e)) {
                for (var s = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"], a = this, l = 0, c = s.length; c > l; l++) a[s[l]] = n(a[s[l]], a);
                i && (e.addEventListener("mouseover", this.onMouse, !0), e.addEventListener("mousedown", this.onMouse, !0), e.addEventListener("mouseup", this.onMouse, !0)), e.addEventListener("click", this.onClick, !0), e.addEventListener("touchstart", this.onTouchStart, !1), e.addEventListener("touchmove", this.onTouchMove, !1), e.addEventListener("touchend", this.onTouchEnd, !1), e.addEventListener("touchcancel", this.onTouchCancel, !1), Event.prototype.stopImmediatePropagation || (e.removeEventListener = function(t, i, o) {
                    var n = Node.prototype.removeEventListener;
                    "click" === t ? n.call(e, t, i.hijacked || i, o) : n.call(e, t, i, o)
                }, e.addEventListener = function(t, i, o) {
                    var n = Node.prototype.addEventListener;
                    "click" === t ? n.call(e, t, i.hijacked || (i.hijacked = function(t) {
                        t.propagationStopped || i(t)
                    }), o) : n.call(e, t, i, o)
                }), "function" == typeof e.onclick && (r = e.onclick, e.addEventListener("click", function(t) {
                    r(t)
                }, !1), e.onclick = null)
            }
        }
        var e = navigator.userAgent.indexOf("Windows Phone") >= 0,
            i = navigator.userAgent.indexOf("Android") > 0 && !e,
            o = /iP(ad|hone|od)/.test(navigator.userAgent) && !e,
            n = o && /OS 4_\d(_\d)?/.test(navigator.userAgent),
            r = o && /OS [6-7]_\d/.test(navigator.userAgent),
            s = navigator.userAgent.indexOf("BB10") > 0;
        t.prototype.needsClick = function(t) {
            switch (t.nodeName.toLowerCase()) {
                case "button":
                case "select":
                case "textarea":
                    if (t.disabled) return !0;
                    break;
                case "input":
                    if (o && "file" === t.type || t.disabled) return !0;
                    break;
                case "label":
                case "iframe":
                case "video":
                    return !0
            }
            return /\bneedsclick\b/.test(t.className)
        }, t.prototype.needsFocus = function(t) {
            switch (t.nodeName.toLowerCase()) {
                case "textarea":
                    return !0;
                case "select":
                    return !i;
                case "input":
                    switch (t.type) {
                        case "button":
                        case "checkbox":
                        case "file":
                        case "image":
                        case "radio":
                        case "submit":
                            return !1
                    }
                    return !t.disabled && !t.readOnly;
                default:
                    return /\bneedsfocus\b/.test(t.className)
            }
        }, t.prototype.sendClick = function(t, e) {
            var i, o;
            document.activeElement && document.activeElement !== t && document.activeElement.blur(), o = e.changedTouches[0], i = document.createEvent("MouseEvents"), i.initMouseEvent(this.determineEventType(t), !0, !0, window, 1, o.screenX, o.screenY, o.clientX, o.clientY, !1, !1, !1, !1, 0, null), i.forwardedTouchEvent = !0, t.dispatchEvent(i)
        }, t.prototype.determineEventType = function(t) {
            return i && "select" === t.tagName.toLowerCase() ? "mousedown" : "click"
        }, t.prototype.focus = function(t) {
            var e;
            o && t.setSelectionRange && 0 !== t.type.indexOf("date") && "time" !== t.type && "month" !== t.type ? (e = t.value.length, t.setSelectionRange(e, e)) : t.focus()
        }, t.prototype.updateScrollParent = function(t) {
            var e, i;
            if (e = t.fastClickScrollParent, !e || !e.contains(t)) {
                i = t;
                do {
                    if (i.scrollHeight > i.offsetHeight) {
                        e = i, t.fastClickScrollParent = i;
                        break
                    }
                    i = i.parentElement
                } while (i)
            }
            e && (e.fastClickLastScrollTop = e.scrollTop)
        }, t.prototype.getTargetElementFromEventTarget = function(t) {
            return t.nodeType === Node.TEXT_NODE ? t.parentNode : t
        }, t.prototype.onTouchStart = function(t) {
            var e, i, r;
            if (t.targetTouches.length > 1) return !0;
            if (e = this.getTargetElementFromEventTarget(t.target), i = t.targetTouches[0], o) {
                if (r = window.getSelection(), r.rangeCount && !r.isCollapsed) return !0;
                if (!n) {
                    if (i.identifier && i.identifier === this.lastTouchIdentifier) return t.preventDefault(), !1;
                    this.lastTouchIdentifier = i.identifier, this.updateScrollParent(e)
                }
            }
            return this.trackingClick = !0, this.trackingClickStart = t.timeStamp, this.targetElement = e, this.touchStartX = i.pageX, this.touchStartY = i.pageY, t.timeStamp - this.lastClickTime < this.tapDelay && t.preventDefault(), !0
        }, t.prototype.touchHasMoved = function(t) {
            var e = t.changedTouches[0],
                i = this.touchBoundary;
            return Math.abs(e.pageX - this.touchStartX) > i || Math.abs(e.pageY - this.touchStartY) > i ? !0 : !1
        }, t.prototype.onTouchMove = function(t) {
            return this.trackingClick ? ((this.targetElement !== this.getTargetElementFromEventTarget(t.target) || this.touchHasMoved(t)) && (this.trackingClick = !1, this.targetElement = null), !0) : !0
        }, t.prototype.findControl = function(t) {
            return void 0 !== t.control ? t.control : t.htmlFor ? document.getElementById(t.htmlFor) : t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")
        }, t.prototype.onTouchEnd = function(t) {
            var e, s, a, l, c, u = this.targetElement;
            if (!this.trackingClick) return !0;
            if (t.timeStamp - this.lastClickTime < this.tapDelay) return this.cancelNextClick = !0, !0;
            if (t.timeStamp - this.trackingClickStart > this.tapTimeout) return !0;
            if (this.cancelNextClick = !1, this.lastClickTime = t.timeStamp, s = this.trackingClickStart, this.trackingClick = !1, this.trackingClickStart = 0, r && (c = t.changedTouches[0], u = document.elementFromPoint(c.pageX - window.pageXOffset, c.pageY - window.pageYOffset) || u, u.fastClickScrollParent = this.targetElement.fastClickScrollParent), a = u.tagName.toLowerCase(), "label" === a) {
                if (e = this.findControl(u)) {
                    if (this.focus(u), i) return !1;
                    u = e
                }
            } else if (this.needsFocus(u)) return t.timeStamp - s > 100 || o && window.top !== window && "input" === a ? (this.targetElement = null, !1) : (this.focus(u), this.sendClick(u, t), o && "select" === a || (this.targetElement = null, t.preventDefault()), !1);
            if (o && !n) {
                l = u.fastClickScrollParent;
                var d = l ? l.fastClickLastScrollTop - l.scrollTop : void 0;
                if (l && !(d > -2 && 2 > d)) return !0
            }
            return this.needsClick(u) || (t.preventDefault(), this.sendClick(u, t)), !1
        }, t.prototype.onTouchCancel = function() {
            this.trackingClick = !1, this.targetElement = null
        }, t.prototype.onMouse = function(t) {
            return this.targetElement ? t.forwardedTouchEvent ? !0 : t.cancelable && (!this.needsClick(this.targetElement) || this.cancelNextClick) ? (t.stopImmediatePropagation ? t.stopImmediatePropagation() : t.propagationStopped = !0, t.stopPropagation(), t.preventDefault(), !1) : !0 : !0
        }, t.prototype.onClick = function(t) {
            var e;
            return this.trackingClick ? (this.targetElement = null, this.trackingClick = !1, !0) : "submit" === t.target.type && 0 === t.detail ? !0 : (e = this.onMouse(t), e || (this.targetElement = null), e)
        }, t.prototype.destroy = function() {
            var t = this.layer;
            i && (t.removeEventListener("mouseover", this.onMouse, !0),
                t.removeEventListener("mousedown", this.onMouse, !0), t.removeEventListener("mouseup", this.onMouse, !0)), t.removeEventListener("click", this.onClick, !0), t.removeEventListener("touchstart", this.onTouchStart, !1), t.removeEventListener("touchmove", this.onTouchMove, !1), t.removeEventListener("touchend", this.onTouchEnd, !1), t.removeEventListener("touchcancel", this.onTouchCancel, !1)
        }, t.notNeeded = function(t) {
            var e, o, n, r;
            if ("undefined" == typeof window.ontouchstart) return !0;
            if (o = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1]) {
                if (!i) return !0;
                if (e = document.querySelector("meta[name=viewport]")) {
                    if (-1 !== e.content.indexOf("user-scalable=no")) return !0;
                    if (o > 31 && document.documentElement.scrollWidth <= window.outerWidth) return !0
                }
            }
            if (s && (n = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/), n[1] >= 10 && n[2] >= 3 && (e = document.querySelector("meta[name=viewport]")))) {
                if (-1 !== e.content.indexOf("user-scalable=no")) return !0;
                if (document.documentElement.scrollWidth <= window.outerWidth) return !0
            }
            return "none" === t.style.msTouchAction || "manipulation" === t.style.touchAction ? !0 : (r = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1], r >= 27 && (e = document.querySelector("meta[name=viewport]"), e && (-1 !== e.content.indexOf("user-scalable=no") || document.documentElement.scrollWidth <= window.outerWidth)) ? !0 : "none" === t.style.touchAction || "manipulation" === t.style.touchAction ? !0 : !1)
        }, t.attach = function(e, i) {
            return new t(e, i)
        }, "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
            return t
        }) : "undefined" != typeof module && module.exports ? (module.exports = t.attach, module.exports.FastClick = t) : window.FastClick = t
    }();
var qualifyURL = function(t) {
    var e = document.createElement("img");
    return e.src = t, t = e.src, e.src = null, t
};
! function(t, e, i, o) {
    function n(e, i) {
        this.element = e, this.$element = t(e), this.settings = t.extend({}, s, i), this.settings.gridSize || (this.settings.gridSize = 5), this._defaults = s, this._name = r, this.tiles = [], this._loadedImages = 0, this.edges = [], this.currentWidth = 0, this.currentImageSizeFactor = 1, this.ajaxComplete = !1, this.isLoading = !1, this.currentPage = 1, this.init()
    }
    t.fn.visible = function(i) {
        if (!t(this).offset()) return !0;
        var o = t(this),
            n = t(e),
            r = n.scrollTop(),
            s = r + n.height(),
            a = o.offset().top,
            l = a + o.height(),
            c = i === !0 ? l : a,
            u = i === !0 ? a : l;
        return s >= u && c >= r
    };
    var r = "finalTilesGallery",
        s = {
            margin: 10,
            minTileWidth: 200,
            ignoreImageAttributes: !0,
            imageSizeFactor: [
                [4e3, .9],
                [1024, .8],
                [800, .7],
                [600, .6],
                [480, .5],
                [320, .3]
            ],
            gridSize: 50,
            allowEnlargement: !0,
            allowImageEnlargment: !0,
            autoLoadURL: null,
            autoLoadOffset: 50,
            onComplete: function() {},
            onUpdate: function() {},
            debug: !1
        };
    t.extend(n.prototype, {
        setCurrentImageSizeFactor: function() {
            this.currentImageSizeFactor = 1;
            for (var i = t(e).width(), o = 0; o < this.settings.imageSizeFactor.length; o++) this.settings.imageSizeFactor[o][0] >= i && (this.currentImageSizeFactor = this.settings.imageSizeFactor[o][1]);
            this.currentImageSizeFactor || (this.currentImageSizeFactor = 1)
        },
        init: function() {
            var o = this;
            this.$element.find(".ftg-items").css({
                position: "relative"
            }), this.tiles = this.$element.find(".tile").not(".ftg-hidden"), this.tiles.css({
                transition: "opacity .25s ease-in-out"
            }), this.currentWidth = this.$element.width();
            var n = 0;
            this.setCurrentImageSizeFactor(), t(e).resize(function() {
                n = setTimeout(function() {
                    o.currentWidth != o.$element.width() && (clearTimeout(n), o.currentWidth = o.$element.width(), o.setCurrentImageSizeFactor(), o.refresh())
                }, 500)
            }), o.settings.autoLoadURL && t(e).scroll(function() {
                o.ajaxComplete || o.isLoading || t(e).scrollTop() >= t(i).height() - t(e).height() - o.settings.autoLoadOffset && (o.isLoading = !0, t.get(o.settings.autoLoadURL, {
                    page: ++o.currentPage
                }, function(e) {
                    0 == t.trim(e).length ? o.ajaxComplete = !0 : (o.$element.find(".ftg-items").append(e), o.tiles = o.$element.find(".tile"), o.loadImage())
                }))
            }), this.edges.push({
                left: 0,
                top: 0,
                width: this.currentWidth,
                index: 0
            }), this.loadImage()
        },
        refresh: function() {
            this.edges = [{
                left: 0,
                top: 0,
                width: this.currentWidth
            }], this.tiles.removeClass("ftg-loaded ftg-enlarged"), this.tiles = this.$element.find(".tile").not(".ftg-hidden"), this._loadedImages = 0, this.loadImage()
        },
        loadImage: function() {
            function t() {
                if (e.add(e._loadedImages), ++e._loadedImages < e.tiles.length) e.loadImage();
                else {
                    var t = e.lowerEdgeTop();
                    e.$element.find(".ftg-items").height(t), e.isLoading = !1, e.tiles.css({
                        transition: "all .25s ease-in-out"
                    }), e.settings.onComplete()
                }
            }
            var e = this,
                i = this.tiles.eq(this._loadedImages);
            i.children("iframe").length && i.children("iframe").addClass("item");
            var o = i.find(".item");
            if (0 == o.length) return void t();
            switch (o.get(0).tagName.toLowerCase()) {
                case "img":
                    var n = new Image;
                    n.onload = function() {
                        var r = e.currentImageSizeFactor;
                        if (i.data("ftg-ignore-size-factor") && (r = 1), n.width < e.settings.minTileWidth) {
                            var s = e.settings.minTileWidth;
                            if (e.settings.allowImageEnlargment) var a = n.height * (e.settings.minTileWidth / n.width);
                            else var a = n.height
                        } else var s = n.width,
                            a = n.height;
                        300 > a && (a = 300), o.attr("src", this.src), o.data("width", s * r), o.data("height", a * r), o.data("owidth", n.width), o.data("oheight", n.height), t()
                    }, n.onerror = function() {
                        t()
                    }, n.src = o.data("ftg-src"), i.data("ftg-type", "image");
                    break;
                case "iframe":
                    o.data("width", parseInt(o.attr("width"))), o.data("height", parseInt(o.attr("height"))), o.data("owidth", parseInt(o.attr("width"))), o.data("oheight", parseInt(o.attr("height"))), i.data("ftg-type", "iframe"), t();
                    break;
                default:
                    o.data("width", o.data("width")), o.data("height", o.data("height")), o.data("owidth", o.data("width")), o.data("oheight", o.data("height")), i.data("ftg-type", "generic"), t()
            }
        },
        higherEdge: function() {
            for (var t = 1e5, e = 0, i = 0; i < this.edges.length; i++) this.edges[i].top < t && (e = i, t = this.edges[i].top);
            return this.edges[e]
        },
        lowerEdgeTop: function() {
            for (var t = 0, e = 0; e < this.edges.length; e++) this.edges[e].top > t && (t = this.edges[e].top);
            return t
        },
        alignEdge: function(t, e) {
            for (var i = 0; i < this.edges.length; i++)
                if (this.edges[i].left + this.edges[i].width + this.settings.margin == t.left && t.top == this.edges[i].top) return {
                    side: "left",
                    edge: this.edges[i]
                };
            for (var i = 0; i < this.edges.length; i++)
                if (this.edges[i].left - this.settings.margin == t.left + t.width && t.top == this.edges[i].top) return {
                    side: "right",
                    edge: this.edges[i]
                };
            return null
        },
        removeEdge: function(t) {
            for (var e = [], i = 0; i < this.edges.length; i++) this.edges[i] != t && e.push(this.edges[i]);
            this.edges = e
        },
        add: function(t) {
            var e = this.tiles.eq(t),
                i = e.find(".item"),
                o = i.data("width"),
                n = i.data("height"),
                r = this.higherEdge();
            if (r.tileIndex = t, r.top > 0 && (r.top += this.settings.margin), e.css(Modernizr.csstransforms ? {
                    transform: "translate(" + Math.round(r.left) + "px, " + Math.round(r.top) + "px)",
                    position: "absolute"
                } : {
                    left: r.left,
                    top: r.top,
                    position: "absolute"
                }), e.attr("data-tile-width") || e.attr("data-tile-width", r.width), r.enlarged = !1, r.width < o + this.settings.margin) {
                r.edgeCase = "Te";
                var s = r.width,
                    a = n / o * s;
                s + r.left - this.settings.margin == this.currentWidth && (s -= this.settings.margin, a = n / o * s), o = s, n = a
            } else if (r.width > o)
                if (r.width - o >= this.settings.minTileWidth) {
                    r.edgeCase = "tE";
                    var l = {
                        left: r.left + o + this.settings.margin,
                        top: r.top - (r.top > 0 ? this.settings.margin : 0),
                        width: r.width - o - this.settings.margin,
                        marginLeft: !0,
                        edgeCase: "NEW",
                        index: r.index + 1
                    };
                    this.edges.push(l)
                } else {
                    r.edgeCase = "tE2";
                    var c = (r.left + r.width == this.currentWidth ? 0 : this.settings.margin, i.data("disallow-enlargment") || !1),
                        s = r.width,
                        a = this.settings.allowEnlargement && !c ? n / o * s : n;
                    this.settings.allowEnlargement && !c ? (e.addClass("ftg-enlarged"), r.enlarged = !0) : e.find(".item").css({
                        width: o,
                        height: n
                    }), o = s, n = a
                }
            r.top += n;
            var u = r.top % this.settings.gridSize;
            r.top -= u, n -= u, r.left = r.left, r.width = o;
            var d = this.alignEdge(r, t);
            d && ("left" == d.side ? (this.removeEdge(r), d.edge.width += o + this.settings.margin, n -= r.top - d.edge.top, r.top -= n) : (this.removeEdge(d.edge), r.width += this.settings.margin + d.edge.width), e.height(n)), this.$element.find(".ftg-items").height() < r.top && this.$element.find(".ftg-items").height(r.top), "iframe" == e.data("ftg-type") && e.find("iframe").height(n), e.css({
                width: o,
                height: n
            });
            var p = o / i.data("width"),
                h = i.data("height") * p - n;
            i.css({
                top: 0 - h / 2
            }), e.addClass("ftg-loaded")
        }
    }), t.fn[r] = function(e) {
        return this.each(function() {
            t.data(this, "plugin_" + r) || t.data(this, "plugin_" + r, new n(this, e))
        }), this
    }
}(jQuery, window, document),
function(t, e) {
    "use strict";

    function i(i, o) {
        this.options = t.extend({}, a, o), this.$element = t(i), this.$win = t(e), this.$loadingClassTarget = this._getLoadingClassTarget(), this.$scrollContainer = this._getScrollContainer(), this.loading = !1, this.doneLoadingInt = null, this.pageCount = this.options.triggerInitialLoad ? this.options.startingPageCount - 1 : this.options.startingPageCount, this.destroyed = !1, this._init()
    }

    function o(e, i, o) {
        e && t.isFunction(e[i]) && e[i].apply(e, o)
    }

    function n(t, e, i) {
        var o;
        return function() {
            var n = this,
                r = arguments,
                s = function() {
                    o = null, i || t.apply(n, r)
                },
                a = i && !o;
            clearTimeout(o), o = setTimeout(s, e), a && t.apply(n, r)
        }
    }
    var r = "infiniteScrollHelper",
        s = "plugin_" + r,
        a = {
            bottomBuffer: 0,
            debounceInt: 100,
            doneLoading: null,
            interval: 300,
            loadingClass: "loading",
            loadingClassTarget: null,
            loadMoreDelay: 0,
            loadMore: t.noop,
            startingPageCount: 1,
            triggerInitialLoad: !1
        };
    i.prototype._init = function() {
        this._addListeners(), this.options.triggerInitialLoad ? this._beginLoadMore(this.options.loadMoreDelay) : this._handleScroll()
    }, i.prototype._getLoadingClassTarget = function() {
        return this.options.loadingClassTarget ? t(this.options.loadingClassTarget) : this.$element
    }, i.prototype._getScrollContainer = function() {
        var e = null;
        return "scroll" == this.$element.css("overflow-y") && (e = this.$element), e || (e = this.$element.parents().filter(function() {
            return "scroll" == t(this).css("overflow-y")
        })), e = e.length > 0 ? e : this.$win
    }, i.prototype._addListeners = function() {
        var t = this;
        this.$scrollContainer.on("scroll." + r, n(function() {
            t._handleScroll()
        }, this.options.debounceInt))
    }, i.prototype._removeListeners = function() {
        this.$scrollContainer.off("scroll." + r)
    }, i.prototype._handleScroll = function(t) {
        var e = this;
        this._shouldTriggerLoad() && (this._beginLoadMore(this.options.loadMoreDelay), this.options.doneLoading && (this.doneLoadingInt = setInterval(function() {
            e.options.doneLoading(e.pageCount) && e._endLoadMore()
        }, this.options.interval)))
    }, i.prototype._shouldTriggerLoad = function() {
        var t = this._getElementHeight(),
            e = this.$scrollContainer.scrollTop() + this.$scrollContainer.height() + this.options.bottomBuffer;
        return !this.loading && e >= t && this.$element.is(":visible")
    }, i.prototype._getElementHeight = function() {
        return this.$element == this.$scrollContainer ? this.$element[0].scrollHeight : this.$element.height()
    }, i.prototype._beginLoadMore = function(e) {
        e = e || 0, setTimeout(t.proxy(function() {
            this.pageCount++, this.options.loadMore(this.pageCount, t.proxy(this._endLoadMore, this)), this.$loadingClassTarget.addClass(this.options.loadingClass)
        }, this), e), this.loading = !0, this._removeListeners()
    }, i.prototype._endLoadMore = function() {
        clearInterval(this.doneLoadingInt), this.loading = !1, this.$loadingClassTarget.removeClass(this.options.loadingClass), !this.destroyed && this._addListeners()
    }, i.prototype.destroy = function() {
        this._removeListeners(), this.options.loadMore = null, this.options.doneLoading = null, t.data(this.$element[0], s, null), clearInterval(this.doneLoadingInt), this.destroyed = !0
    }, t.fn[r] = function(e) {
        var n = !1,
            r = arguments;
        return "string" == typeof e && (n = e), this.each(function() {
            var a = t.data(this, s);
            a || n ? n && o(a, n, Array.prototype.slice.call(r, 1)) : t.data(this, s, new i(this, e))
        })
    }, e.InfiniteScrollHelper = e.InfiniteScrollHelper || i
}(jQuery, window),
function() {
    var t;
    t = function() {
            function t(t, e) {
                var i, o;
                if (this.options = {
                        target: "instafeed",
                        get: "popular",
                        resolution: "thumbnail",
                        sortBy: "none",
                        links: !0,
                        mock: !1,
                        useHttp: !1
                    }, "object" == typeof t)
                    for (i in t) o = t[i], this.options[i] = o;
                this.context = null != e ? e : this, this.unique = this._genKey()
            }
            return t.prototype.hasNext = function() {
                return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0
            }, t.prototype.next = function() {
                return this.hasNext() ? this.run(this.context.nextUrl) : !1
            }, t.prototype.run = function(e) {
                var i, o, n;
                if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken) throw new Error("Missing clientId or accessToken.");
                if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId) throw new Error("Missing clientId or accessToken.");
                return null != this.options.before && "function" == typeof this.options.before && this.options.before.call(this), "undefined" != typeof document && null !== document && (n = document.createElement("script"), n.id = "instafeed-fetcher", n.src = e || this._buildUrl(), i = document.getElementsByTagName("head"), i[0].appendChild(n), o = "instafeedCache" + this.unique, window[o] = new t(this.options, this), window[o].unique = this.unique), !0
            }, t.prototype.parse = function(t) {
                var e, i, o, n, r, s, a, l, c, u, d, p, h, m, f, y, g, v, w, _, b, k, C, T, S, $, x, I, E, A, L, P, M;
                if ("object" != typeof t) {
                    if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "Invalid JSON data"), !1;
                    throw new Error("Invalid JSON response")
                }
                if (200 !== t.meta.code) {
                    if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, t.meta.error_message), !1;
                    throw new Error("Error from Instagram: " + t.meta.error_message)
                }
                if (0 === t.data.length) {
                    if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "No images were returned from Instagram"), !1;
                    throw new Error("No images were returned from Instagram")
                }
                if (null != this.options.success && "function" == typeof this.options.success && this.options.success.call(this, t), this.context.nextUrl = "", null != t.pagination && (this.context.nextUrl = t.pagination.next_url), "none" !== this.options.sortBy) switch (L = "random" === this.options.sortBy ? ["", "random"] : this.options.sortBy.split("-"), A = "least" === L[0] ? !0 : !1, L[1]) {
                    case "random":
                        t.data.sort(function() {
                            return .5 - Math.random()
                        });
                        break;
                    case "recent":
                        t.data = this._sortBy(t.data, "created_time", A);
                        break;
                    case "liked":
                        t.data = this._sortBy(t.data, "likes.count", A);
                        break;
                    case "commented":
                        t.data = this._sortBy(t.data, "comments.count", A);
                        break;
                    default:
                        throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.")
                }
                if ("undefined" != typeof document && null !== document && this.options.mock === !1) {
                    if (y = t.data, E = parseInt(this.options.limit, 10), null != this.options.limit && y.length > E && (y = y.slice(0, E)), a = document.createDocumentFragment(), null != this.options.filter && "function" == typeof this.options.filter && (y = this._filter(y, this.options.filter)), null != this.options.template && "string" == typeof this.options.template) {
                        for (c = "", m = "", _ = "", M = document.createElement("div"), d = 0, S = y.length; S > d; d++) {
                            if (p = y[d], h = p.images[this.options.resolution], "object" != typeof h) throw s = "No image found for resolution: " + this.options.resolution + ".", new Error(s);
                            b = h.width, v = h.height, w = "square", b > v && (w = "landscape"), v > b && (w = "portrait"), f = h.url, u = window.location.protocol.indexOf("http") >= 0, u && !this.options.useHttp && (f = f.replace(/https?:\/\//, "//")), m = this._makeTemplate(this.options.template, {
                                model: p,
                                id: p.id,
                                link: p.link,
                                type: p.type,
                                image: f,
                                width: b,
                                height: v,
                                orientation: w,
                                caption: this._getObjectProperty(p, "caption.text"),
                                likes: p.likes.count,
                                comments: p.comments.count,
                                location: this._getObjectProperty(p, "location.name")
                            }), c += m
                        }
                        for (M.innerHTML = c, n = [], o = 0, i = M.childNodes.length; i > o;) n.push(M.childNodes[o]), o += 1;
                        for (C = 0, $ = n.length; $ > C; C++) I = n[C], a.appendChild(I)
                    } else
                        for (T = 0, x = y.length; x > T; T++) {
                            if (p = y[T], g = document.createElement("img"), h = p.images[this.options.resolution], "object" != typeof h) throw s = "No image found for resolution: " + this.options.resolution + ".", new Error(s);
                            f = h.url, u = window.location.protocol.indexOf("http") >= 0, u && !this.options.useHttp && (f = f.replace(/https?:\/\//, "//")), g.src = f, this.options.links === !0 ? (e = document.createElement("a"), e.href = p.link, e.appendChild(g), a.appendChild(e)) : a.appendChild(g)
                        }
                    if (P = this.options.target, "string" == typeof P && (P = document.getElementById(P)), null == P) throw s = 'No element with id="' + this.options.target + '" on page.', new Error(s);
                    P.appendChild(a), l = document.getElementsByTagName("head")[0], l.removeChild(document.getElementById("instafeed-fetcher")), k = "instafeedCache" + this.unique, window[k] = void 0;
                    try {
                        delete window[k]
                    } catch (D) {
                        r = D
                    }
                }
                return null != this.options.after && "function" == typeof this.options.after && this.options.after.call(this), !0
            }, t.prototype._buildUrl = function() {
                var t, e, i;
                switch (t = "https://api.instagram.com/v1", this.options.get) {
                    case "popular":
                        e = "media/popular";
                        break;
                    case "tagged":
                        if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                        e = "tags/" + this.options.tagName + "/media/recent";
                        break;
                    case "location":
                        if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                        e = "locations/" + this.options.locationId + "/media/recent";
                        break;
                    case "user":
                        if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                        e = "users/" + this.options.userId + "/media/recent";
                        break;
                    default:
                        throw new Error("Invalid option for get: '" + this.options.get + "'.")
                }
                return i = t + "/" + e, i += null != this.options.accessToken ? "?access_token=" + this.options.accessToken : "?client_id=" + this.options.clientId, null != this.options.limit && (i += "&count=" + this.options.limit), i += "&callback=instafeedCache" + this.unique + ".parse"
            }, t.prototype._genKey = function() {
                var t;
                return t = function() {
                    return (65536 * (1 + Math.random()) | 0).toString(16).substring(1)
                }, "" + t() + t() + t() + t()
            }, t.prototype._makeTemplate = function(t, e) {
                var i, o, n, r, s;
                for (o = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, i = t; o.test(i);) r = i.match(o)[1], s = null != (n = this._getObjectProperty(e, r)) ? n : "", i = i.replace(o, function() {
                    return "" + s
                });
                return i
            }, t.prototype._getObjectProperty = function(t, e) {
                var i, o;
                for (e = e.replace(/\[(\w+)\]/g, ".$1"), o = e.split("."); o.length;) {
                    if (i = o.shift(), !(null != t && i in t)) return null;
                    t = t[i]
                }
                return t
            }, t.prototype._sortBy = function(t, e, i) {
                var o;
                return o = function(t, o) {
                    var n, r;
                    return n = this._getObjectProperty(t, e), r = this._getObjectProperty(o, e), i ? n > r ? 1 : -1 : r > n ? 1 : -1
                }, t.sort(o.bind(this)), t
            }, t.prototype._filter = function(t, e) {
                var i, o, n, r, s;
                for (i = [], o = function(t) {
                        return e(t) ? i.push(t) : void 0
                    }, n = 0, s = t.length; s > n; n++) r = t[n], o(r);
                return i
            }, t
        }(),
        function(t, e) {
            return "function" == typeof define && define.amd ? define([], e) : "object" == typeof module && module.exports ? module.exports = e() : t.Instafeed = e()
        }(this, function() {
            return t
        })
}.call(this);
var Shopify = Shopify || {};
Shopify.optionsMap = {}, Shopify.updateOptionsInSelector = function(t) {
        switch (t) {
            case 0:
                var e = "root",
                    i = jQuery(".single-option-selector:eq(0)");
                break;
            case 1:
                var e = jQuery(".single-option-selector:eq(0)").val(),
                    i = jQuery(".single-option-selector:eq(1)");
                break;
            case 2:
                var e = jQuery(".single-option-selector:eq(0)").val();
                e += " / " + jQuery(".single-option-selector:eq(1)").val();
                var i = jQuery(".single-option-selector:eq(2)")
        }
        var o = i.val();
        i.empty();
        for (var n = Shopify.optionsMap[e], r = 0; r < n.length; r++) {
            var s = n[r],
                a = jQuery("<option></option>").val(s).html(s);
            i.append(a)
        }
        jQuery('.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
            -1 !== jQuery.inArray($(this).attr("data-value"), n) ? $(this).removeClass("sold-out active").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("sold-out").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }), -1 !== jQuery.inArray(o, n) && i.val(o), i.trigger("change")
    }, Shopify.linkOptionSelectors = function(t) {
        Shopify.optionsMap = [];
        for (var e = 0; e < t.variants.length; e++) {
            var i = t.variants[e];
            if (i.available) {
                if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(i.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), t.options.length > 1) {
                    var o = i.option1;
                    Shopify.optionsMap[o] = Shopify.optionsMap[o] || [], Shopify.optionsMap[o].push(i.option2), Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
                }
                if (3 === t.options.length) {
                    var o = i.option1 + " / " + i.option2;
                    Shopify.optionsMap[o] = Shopify.optionsMap[o] || [], Shopify.optionsMap[o].push(i.option3), Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
                }
            }
        }
        Shopify.updateOptionsInSelector(0), t.options.length > 1 && Shopify.updateOptionsInSelector(1), 3 === t.options.length && Shopify.updateOptionsInSelector(2), jQuery(".single-option-selector:eq(0)").change(function() {
            return Shopify.updateOptionsInSelector(1), 3 === t.options.length && Shopify.updateOptionsInSelector(2), !0
        }), jQuery(".single-option-selector:eq(1)").change(function() {
            return 3 === t.options.length && Shopify.updateOptionsInSelector(2), !0
        })
    },
    function() {
        function t(t, i, o, n) {
            return new e(t, i, o, n)
        }

        function e(t, e, o, n) {
            this.options = n || {}, this.options.adapters = this.options.adapters || {}, this.obj = t, this.keypath = e, this.callback = o, this.objectPath = [], this.parse(), i(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
        }

        function i(t) {
            return "object" == typeof t && null !== t
        }

        function o(t) {
            throw new Error("[sightglass] " + t)
        }
        t.adapters = {}, e.tokenize = function(t, e, i) {
            var o, n, r = [],
                s = {
                    i: i,
                    path: ""
                };
            for (o = 0; o < t.length; o++) n = t.charAt(o), ~e.indexOf(n) ? (r.push(s), s = {
                i: n,
                path: ""
            }) : s.path += n;
            return r.push(s), r
        }, e.prototype.parse = function() {
            var i, n, r = this.interfaces();
            r.length || o("Must define at least one adapter interface."), ~r.indexOf(this.keypath[0]) ? (i = this.keypath[0], n = this.keypath.substr(1)) : ("undefined" == typeof(i = this.options.root || t.root) && o("Must define a default root adapter."), n = this.keypath), this.tokens = e.tokenize(n, r, i), this.key = this.tokens.pop()
        }, e.prototype.realize = function() {
            var t, e = this.obj,
                o = !1;
            return this.tokens.forEach(function(n, r) {
                i(e) ? ("undefined" != typeof this.objectPath[r] ? e !== (t = this.objectPath[r]) && (this.set(!1, n, t, this.update.bind(this)), this.set(!0, n, e, this.update.bind(this)), this.objectPath[r] = e) : (this.set(!0, n, e, this.update.bind(this)), this.objectPath[r] = e), e = this.get(n, e)) : (o === !1 && (o = r), (t = this.objectPath[r]) && this.set(!1, n, t, this.update.bind(this)))
            }, this), o !== !1 && this.objectPath.splice(o), e
        }, e.prototype.update = function() {
            var t, e;
            (t = this.realize()) !== this.target && (i(this.target) && this.set(!1, this.key, this.target, this.callback), i(t) && this.set(!0, this.key, t, this.callback), e = this.value(), this.target = t, this.value() !== e && this.callback())
        }, e.prototype.value = function() {
            return i(this.target) ? this.get(this.key, this.target) : void 0
        }, e.prototype.setValue = function(t) {
            i(this.target) && this.adapter(this.key).set(this.target, this.key.path, t)
        }, e.prototype.get = function(t, e) {
            return this.adapter(t).get(e, t.path)
        }, e.prototype.set = function(t, e, i, o) {
            var n = t ? "observe" : "unobserve";
            this.adapter(e)[n](i, e.path, o)
        }, e.prototype.interfaces = function() {
            var e = Object.keys(this.options.adapters);
            return Object.keys(t.adapters).forEach(function(t) {
                ~e.indexOf(t) || e.push(t)
            }), e
        }, e.prototype.adapter = function(e) {
            return this.options.adapters[e.i] || t.adapters[e.i]
        }, e.prototype.unobserve = function() {
            var t;
            this.tokens.forEach(function(e, i) {
                (t = this.objectPath[i]) && this.set(!1, e, t, this.update.bind(this))
            }, this), i(this.target) && this.set(!1, this.key, this.target, this.callback)
        }, "undefined" != typeof module && module.exports ? module.exports = t : "function" == typeof define && define.amd ? define([], function() {
            return this.sightglass = t
        }) : this.sightglass = t
    }.call(this),
    function() {
        var t, e, i, o, n = function(t, e) {
                return function() {
                    return t.apply(e, arguments)
                }
            },
            r = [].slice,
            s = {}.hasOwnProperty,
            a = function(t, e) {
                function i() {
                    this.constructor = t
                }
                for (var o in e) s.call(e, o) && (t[o] = e[o]);
                return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
            },
            l = [].indexOf || function(t) {
                for (var e = 0, i = this.length; i > e; e++)
                    if (e in this && this[e] === t) return e;
                return -1
            };
        t = {
            options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"],
            extensions: ["binders", "formatters", "components", "adapters"],
            "public": {
                binders: {},
                components: {},
                formatters: {},
                adapters: {},
                prefix: "rv",
                templateDelimiters: ["{", "}"],
                rootInterface: ".",
                preloadData: !0,
                handler: function(t, e, i) {
                    return this.call(t, e, i.view.models)
                },
                configure: function(e) {
                    var i, o, n, r;
                    null == e && (e = {});
                    for (n in e)
                        if (r = e[n], "binders" === n || "components" === n || "formatters" === n || "adapters" === n)
                            for (o in r) i = r[o], t[n][o] = i;
                        else t["public"][n] = r
                },
                bind: function(e, i, o) {
                    var n;
                    return null == i && (i = {}), null == o && (o = {}), n = new t.View(e, i, o), n.bind(), n
                },
                init: function(e, i, o) {
                    var n, r;
                    return null == o && (o = {}), null == i && (i = document.createElement("div")), e = t["public"].components[e], i.innerHTML = e.template.call(this, i), n = e.initialize.call(this, i, o), r = new t.View(i, n), r.bind(), r
                }
            }
        }, window.jQuery || window.$ ? (o = "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"], e = o[0], i = o[1], t.Util = {
            bindEvent: function(t, i, o) {
                return jQuery(t)[e](i, o)
            },
            unbindEvent: function(t, e, o) {
                return jQuery(t)[i](e, o)
            },
            getInputValue: function(t) {
                var e;
                return e = jQuery(t), "checkbox" === e.attr("type") ? e.is(":checked") : e.val()
            }
        }) : t.Util = {
            bindEvent: function() {
                return "addEventListener" in window ? function(t, e, i) {
                    return t.addEventListener(e, i, !1)
                } : function(t, e, i) {
                    return t.attachEvent("on" + e, i)
                }
            }(),
            unbindEvent: function() {
                return "removeEventListener" in window ? function(t, e, i) {
                    return t.removeEventListener(e, i, !1)
                } : function(t, e, i) {
                    return t.detachEvent("on" + e, i)
                }
            }(),
            getInputValue: function(t) {
                var e, i, o, n;
                if ("checkbox" === t.type) return t.checked;
                if ("select-multiple" === t.type) {
                    for (n = [], i = 0, o = t.length; o > i; i++) e = t[i], e.selected && n.push(e.value);
                    return n
                }
                return t.value
            }
        }, t.TypeParser = function() {
            function t() {}
            return t.types = {
                primitive: 0,
                keypath: 1
            }, t.parse = function(t) {
                return /^'.*'$|^".*"$/.test(t) ? {
                    type: this.types.primitive,
                    value: t.slice(1, -1)
                } : "true" === t ? {
                    type: this.types.primitive,
                    value: !0
                } : "false" === t ? {
                    type: this.types.primitive,
                    value: !1
                } : "null" === t ? {
                    type: this.types.primitive,
                    value: null
                } : "undefined" === t ? {
                    type: this.types.primitive,
                    value: void 0
                } : isNaN(Number(t)) === !1 ? {
                    type: this.types.primitive,
                    value: Number(t)
                } : {
                    type: this.types.keypath,
                    value: t
                }
            }, t
        }(), t.TextTemplateParser = function() {
            function t() {}
            return t.types = {
                text: 0,
                binding: 1
            }, t.parse = function(t, e) {
                var i, o, n, r, s, a, l;
                for (a = [], r = t.length, i = 0, o = 0; r > o;) {
                    if (i = t.indexOf(e[0], o), 0 > i) {
                        a.push({
                            type: this.types.text,
                            value: t.slice(o)
                        });
                        break
                    }
                    if (i > 0 && i > o && a.push({
                            type: this.types.text,
                            value: t.slice(o, i)
                        }), o = i + e[0].length, i = t.indexOf(e[1], o), 0 > i) {
                        s = t.slice(o - e[1].length), n = a[a.length - 1], (null != n ? n.type : void 0) === this.types.text ? n.value += s : a.push({
                            type: this.types.text,
                            value: s
                        });
                        break
                    }
                    l = t.slice(o, i).trim(), a.push({
                        type: this.types.binding,
                        value: l
                    }), o = i + e[1].length
                }
                return a
            }, t
        }(), t.View = function() {
            function e(e, i, o) {
                var r, s, a, l, c, u, d, p, h, m, f, y, g;
                for (this.els = e, this.models = i, null == o && (o = {}), this.update = n(this.update, this), this.publish = n(this.publish, this), this.sync = n(this.sync, this), this.unbind = n(this.unbind, this), this.bind = n(this.bind, this), this.select = n(this.select, this), this.traverse = n(this.traverse, this), this.build = n(this.build, this), this.buildBinding = n(this.buildBinding, this), this.bindingRegExp = n(this.bindingRegExp, this), this.options = n(this.options, this), this.els.jquery || this.els instanceof Array || (this.els = [this.els]), h = t.extensions, c = 0, d = h.length; d > c; c++) {
                    if (s = h[c], this[s] = {}, o[s]) {
                        m = o[s];
                        for (r in m) a = m[r], this[s][r] = a
                    }
                    f = t["public"][s];
                    for (r in f) a = f[r], null == (l = this[s])[r] && (l[r] = a)
                }
                for (y = t.options, u = 0, p = y.length; p > u; u++) s = y[u], this[s] = null != (g = o[s]) ? g : t["public"][s];
                this.build()
            }
            return e.prototype.options = function() {
                var e, i, o, n, r;
                for (i = {}, r = t.extensions.concat(t.options), o = 0, n = r.length; n > o; o++) e = r[o], i[e] = this[e];
                return i
            }, e.prototype.bindingRegExp = function() {
                return new RegExp("^" + this.prefix + "-")
            }, e.prototype.buildBinding = function(e, i, o, n) {
                var r, s, a, l, c, u, d;
                return c = {}, d = function() {
                    var t, e, i, o;
                    for (i = n.split("|"), o = [], t = 0, e = i.length; e > t; t++) u = i[t], o.push(u.trim());
                    return o
                }(), r = function() {
                    var t, e, i, o;
                    for (i = d.shift().split("<"), o = [], t = 0, e = i.length; e > t; t++) s = i[t], o.push(s.trim());
                    return o
                }(), l = r.shift(), c.formatters = d, (a = r.shift()) && (c.dependencies = a.split(/\s+/)), this.bindings.push(new t[e](this, i, o, l, c))
            }, e.prototype.build = function() {
                var e, i, o, n, r;
                for (this.bindings = [], i = function(e) {
                        return function(o) {
                            var n, r, s, a, l, c, u, d, p, h, m, f, y, g;
                            if (3 === o.nodeType) {
                                if (l = t.TextTemplateParser, (s = e.templateDelimiters) && (d = l.parse(o.data, s)).length && (1 !== d.length || d[0].type !== l.types.text)) {
                                    for (p = 0, m = d.length; m > p; p++) u = d[p], c = document.createTextNode(u.value), o.parentNode.insertBefore(c, o), 1 === u.type && e.buildBinding("TextBinding", c, null, u.value);
                                    o.parentNode.removeChild(o)
                                }
                            } else 1 === o.nodeType && (n = e.traverse(o));
                            if (!n) {
                                for (y = function() {
                                        var t, e, i, n;
                                        for (i = o.childNodes, n = [], t = 0, e = i.length; e > t; t++) a = i[t], n.push(a);
                                        return n
                                    }(), g = [], h = 0, f = y.length; f > h; h++) r = y[h], g.push(i(r));
                                return g
                            }
                        }
                    }(this), r = this.els, o = 0, n = r.length; n > o; o++) e = r[o], i(e);
                this.bindings.sort(function(t, e) {
                    var i, o;
                    return ((null != (i = e.binder) ? i.priority : void 0) || 0) - ((null != (o = t.binder) ? o.priority : void 0) || 0)
                })
            }, e.prototype.traverse = function(e) {
                var i, o, n, r, s, a, l, c, u, d, p, h, m, f, y, g;
                for (r = this.bindingRegExp(), s = "SCRIPT" === e.nodeName || "STYLE" === e.nodeName, f = e.attributes, d = 0, h = f.length; h > d; d++)
                    if (i = f[d], r.test(i.name)) {
                        if (c = i.name.replace(r, ""), !(n = this.binders[c])) {
                            y = this.binders;
                            for (a in y) u = y[a], "*" !== a && -1 !== a.indexOf("*") && (l = new RegExp("^" + a.replace(/\*/g, ".+") + "$"), l.test(c) && (n = u))
                        }
                        n || (n = this.binders["*"]), n.block && (s = !0, o = [i])
                    }
                for (g = o || e.attributes, p = 0, m = g.length; m > p; p++) i = g[p], r.test(i.name) && (c = i.name.replace(r, ""), this.buildBinding("Binding", e, c, i.value));
                return s || (c = e.nodeName.toLowerCase(), this.components[c] && !e._bound && (this.bindings.push(new t.ComponentBinding(this, e, c)), s = !0)), s
            }, e.prototype.select = function(t) {
                var e, i, o, n, r;
                for (n = this.bindings, r = [], i = 0, o = n.length; o > i; i++) e = n[i], t(e) && r.push(e);
                return r
            }, e.prototype.bind = function() {
                var t, e, i, o, n;
                for (o = this.bindings, n = [], e = 0, i = o.length; i > e; e++) t = o[e], n.push(t.bind());
                return n
            }, e.prototype.unbind = function() {
                var t, e, i, o, n;
                for (o = this.bindings, n = [], e = 0, i = o.length; i > e; e++) t = o[e], n.push(t.unbind());
                return n
            }, e.prototype.sync = function() {
                var t, e, i, o, n;
                for (o = this.bindings, n = [], e = 0, i = o.length; i > e; e++) t = o[e], n.push("function" == typeof t.sync ? t.sync() : void 0);
                return n
            }, e.prototype.publish = function() {
                var t, e, i, o, n;
                for (o = this.select(function(t) {
                        var e;
                        return null != (e = t.binder) ? e.publishes : void 0
                    }), n = [], e = 0, i = o.length; i > e; e++) t = o[e], n.push(t.publish());
                return n
            }, e.prototype.update = function(t) {
                var e, i, o, n, r, s, a;
                null == t && (t = {});
                for (i in t) o = t[i], this.models[i] = o;
                for (s = this.bindings, a = [], n = 0, r = s.length; r > n; n++) e = s[n], a.push("function" == typeof e.update ? e.update(t) : void 0);
                return a
            }, e
        }(), t.Binding = function() {
            function e(t, e, i, o, r) {
                this.view = t, this.el = e, this.type = i, this.keypath = o, this.options = null != r ? r : {}, this.getValue = n(this.getValue, this), this.update = n(this.update, this), this.unbind = n(this.unbind, this), this.bind = n(this.bind, this), this.publish = n(this.publish, this), this.sync = n(this.sync, this), this.set = n(this.set, this), this.eventHandler = n(this.eventHandler, this), this.formattedValue = n(this.formattedValue, this), this.parseTarget = n(this.parseTarget, this), this.observe = n(this.observe, this), this.setBinder = n(this.setBinder, this), this.formatters = this.options.formatters || [], this.dependencies = [], this.formatterObservers = {}, this.model = void 0, this.setBinder()
            }
            return e.prototype.setBinder = function() {
                var t, e, i, o;
                if (!(this.binder = this.view.binders[this.type])) {
                    o = this.view.binders;
                    for (t in o) i = o[t], "*" !== t && -1 !== t.indexOf("*") && (e = new RegExp("^" + t.replace(/\*/g, ".+") + "$"), e.test(this.type) && (this.binder = i, this.args = new RegExp("^" + t.replace(/\*/g, "(.+)") + "$").exec(this.type), this.args.shift()))
                }
                return this.binder || (this.binder = this.view.binders["*"]), this.binder instanceof Function ? this.binder = {
                    routine: this.binder
                } : void 0
            }, e.prototype.observe = function(e, i, o) {
                return t.sightglass(e, i, o, {
                    root: this.view.rootInterface,
                    adapters: this.view.adapters
                })
            }, e.prototype.parseTarget = function() {
                var e;
                return e = t.TypeParser.parse(this.keypath), 0 === e.type ? this.value = e.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync), this.model = this.observer.target)
            }, e.prototype.formattedValue = function(e) {
                var i, o, n, s, a, l, c, u, d, p, h, m, f, y;
                for (y = this.formatters, s = p = 0, m = y.length; m > p; s = ++p) {
                    for (a = y[s], n = a.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g), l = n.shift(), a = this.view.formatters[l], n = function() {
                            var e, i, r;
                            for (r = [], e = 0, i = n.length; i > e; e++) o = n[e], r.push(t.TypeParser.parse(o));
                            return r
                        }(), u = [], i = h = 0, f = n.length; f > h; i = ++h) o = n[i], u.push(0 === o.type ? o.value : ((d = this.formatterObservers)[s] || (d[s] = {}), (c = this.formatterObservers[s][i]) ? void 0 : (c = this.observe(this.view.models, o.value, this.sync), this.formatterObservers[s][i] = c), c.value()));
                    (null != a ? a.read : void 0) instanceof Function ? e = a.read.apply(a, [e].concat(r.call(u))) : a instanceof Function && (e = a.apply(null, [e].concat(r.call(u))))
                }
                return e
            }, e.prototype.eventHandler = function(t) {
                var e, i;
                return i = (e = this).view.handler,
                    function(o) {
                        return i.call(t, this, o, e)
                    }
            }, e.prototype.set = function(t) {
                var e;
                return t = this.formattedValue(t instanceof Function && !this.binder["function"] ? t.call(this.model) : t), null != (e = this.binder.routine) ? e.call(this, this.el, t) : void 0
            }, e.prototype.sync = function() {
                var t, e;
                return this.set(function() {
                    var i, o, n, r, s, a, l;
                    if (this.observer) {
                        if (this.model !== this.observer.target) {
                            for (s = this.dependencies, i = 0, n = s.length; n > i; i++) e = s[i], e.unobserve();
                            if (this.dependencies = [], null != (this.model = this.observer.target) && (null != (a = this.options.dependencies) ? a.length : void 0))
                                for (l = this.options.dependencies, o = 0, r = l.length; r > o; o++) t = l[o], e = this.observe(this.model, t, this.sync), this.dependencies.push(e)
                        }
                        return this.observer.value()
                    }
                    return this.value
                }.call(this))
            }, e.prototype.publish = function() {
                var t, e, i, o, n, s, a, l, c;
                if (this.observer) {
                    for (o = this.getValue(this.el), a = this.formatters.slice(0).reverse(), n = 0, s = a.length; s > n; n++) e = a[n], t = e.split(/\s+/), i = t.shift(), (null != (l = this.view.formatters[i]) ? l.publish : void 0) && (o = (c = this.view.formatters[i]).publish.apply(c, [o].concat(r.call(t))));
                    return this.observer.setValue(o)
                }
            }, e.prototype.bind = function() {
                var t, e, i, o, n, r, s;
                if (this.parseTarget(), null != (n = this.binder.bind) && n.call(this, this.el), null != this.model && (null != (r = this.options.dependencies) ? r.length : void 0))
                    for (s = this.options.dependencies, i = 0, o = s.length; o > i; i++) t = s[i], e = this.observe(this.model, t, this.sync), this.dependencies.push(e);
                return this.view.preloadData ? this.sync() : void 0
            }, e.prototype.unbind = function() {
                var t, e, i, o, n, r, s, a, l, c;
                for (null != (s = this.binder.unbind) && s.call(this, this.el), null != (a = this.observer) && a.unobserve(), l = this.dependencies, n = 0, r = l.length; r > n; n++) o = l[n], o.unobserve();
                this.dependencies = [], c = this.formatterObservers;
                for (i in c) {
                    e = c[i];
                    for (t in e) o = e[t], o.unobserve()
                }
                return this.formatterObservers = {}
            }, e.prototype.update = function(t) {
                var e, i;
                return null == t && (t = {}), this.model = null != (e = this.observer) ? e.target : void 0, null != (i = this.binder.update) ? i.call(this, t) : void 0
            }, e.prototype.getValue = function(e) {
                return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, e) : t.Util.getInputValue(e)
            }, e
        }(), t.ComponentBinding = function(e) {
            function i(t, e, i) {
                var o, r, s, a, c, u, d;
                for (this.view = t, this.el = e, this.type = i, this.unbind = n(this.unbind, this), this.bind = n(this.bind, this), this.locals = n(this.locals, this), this.component = this.view.components[this.type], this["static"] = {}, this.observers = {}, this.upstreamObservers = {}, r = t.bindingRegExp(), u = this.el.attributes || [], a = 0, c = u.length; c > a; a++) o = u[a], r.test(o.name) || (s = this.camelCase(o.name), l.call(null != (d = this.component["static"]) ? d : [], s) >= 0 ? this["static"][s] = o.value : this.observers[s] = o.value)
            }
            return a(i, e), i.prototype.sync = function() {}, i.prototype.update = function() {}, i.prototype.publish = function() {}, i.prototype.locals = function() {
                var t, e, i, o, n, r;
                i = {}, n = this["static"];
                for (t in n) o = n[t], i[t] = o;
                r = this.observers;
                for (t in r) e = r[t], i[t] = e.value();
                return i
            }, i.prototype.camelCase = function(t) {
                return t.replace(/-([a-z])/g, function(t) {
                    return t[1].toUpperCase()
                })
            }, i.prototype.bind = function() {
                var e, i, o, n, r, s, a, l, c, u, d, p, h, m, f, y, g, v, w, _, b;
                if (!this.bound) {
                    m = this.observers;
                    for (i in m) o = m[i], this.observers[i] = this.observe(this.view.models, o, function(t) {
                        return function(e) {
                            return function() {
                                return t.componentView.models[e] = t.observers[e].value()
                            }
                        }
                    }(this).call(this, i));
                    this.bound = !0
                }
                if (null != this.componentView) return this.componentView.bind();
                for (this.el.innerHTML = this.component.template.call(this), a = this.component.initialize.call(this, this.el, this.locals()), this.el._bound = !0, s = {}, f = t.extensions, u = 0, p = f.length; p > u; u++) {
                    if (r = f[u], s[r] = {}, this.component[r]) {
                        y = this.component[r];
                        for (e in y) l = y[e], s[r][e] = l
                    }
                    g = this.view[r];
                    for (e in g) l = g[e], null == (c = s[r])[e] && (c[e] = l)
                }
                for (v = t.options, d = 0, h = v.length; h > d; d++) r = v[d], s[r] = null != (w = this.component[r]) ? w : this.view[r];
                this.componentView = new t.View(this.el, a, s), this.componentView.bind(), _ = this.observers, b = [];
                for (i in _) n = _[i], b.push(this.upstreamObservers[i] = this.observe(this.componentView.models, i, function(t) {
                    return function(e, i) {
                        return function() {
                            return i.setValue(t.componentView.models[e])
                        }
                    }
                }(this).call(this, i, n)));
                return b
            }, i.prototype.unbind = function() {
                var t, e, i, o, n;
                i = this.upstreamObservers;
                for (t in i) e = i[t], e.unobserve();
                o = this.observers;
                for (t in o) e = o[t], e.unobserve();
                return null != (n = this.componentView) ? n.unbind.call(this) : void 0
            }, i
        }(t.Binding), t.TextBinding = function(t) {
            function e(t, e, i, o, r) {
                this.view = t, this.el = e, this.type = i, this.keypath = o, this.options = null != r ? r : {}, this.sync = n(this.sync, this), this.formatters = this.options.formatters || [], this.dependencies = [], this.formatterObservers = {}
            }
            return a(e, t), e.prototype.binder = {
                routine: function(t, e) {
                    return t.data = null != e ? e : ""
                }
            }, e.prototype.sync = function() {
                return e.__super__.sync.apply(this, arguments)
            }, e
        }(t.Binding), t["public"].binders.text = function(t, e) {
            return null != t.textContent ? t.textContent = null != e ? e : "" : t.innerText = null != e ? e : ""
        }, t["public"].binders.html = function(t, e) {
            return t.innerHTML = null != e ? e : ""
        }, t["public"].binders.show = function(t, e) {
            return t.style.display = e ? "" : "none"
        }, t["public"].binders.hide = function(t, e) {
            return t.style.display = e ? "none" : ""
        }, t["public"].binders.enabled = function(t, e) {
            return t.disabled = !e
        }, t["public"].binders.disabled = function(t, e) {
            return t.disabled = !!e
        }, t["public"].binders.checked = {
            publishes: !0,
            priority: 2e3,
            bind: function(e) {
                return t.Util.bindEvent(e, "change", this.publish)
            },
            unbind: function(e) {
                return t.Util.unbindEvent(e, "change", this.publish)
            },
            routine: function(t, e) {
                var i;
                return t.checked = "radio" === t.type ? (null != (i = t.value) ? i.toString() : void 0) === (null != e ? e.toString() : void 0) : !!e
            }
        }, t["public"].binders.unchecked = {
            publishes: !0,
            priority: 2e3,
            bind: function(e) {
                return t.Util.bindEvent(e, "change", this.publish)
            },
            unbind: function(e) {
                return t.Util.unbindEvent(e, "change", this.publish)
            },
            routine: function(t, e) {
                var i;
                return t.checked = "radio" === t.type ? (null != (i = t.value) ? i.toString() : void 0) !== (null != e ? e.toString() : void 0) : !e
            }
        }, t["public"].binders.value = {
            publishes: !0,
            priority: 3e3,
            bind: function(e) {
                return "INPUT" !== e.tagName || "radio" !== e.type ? (this.event = "SELECT" === e.tagName ? "change" : "input", t.Util.bindEvent(e, this.event, this.publish)) : void 0
            },
            unbind: function(e) {
                return "INPUT" !== e.tagName || "radio" !== e.type ? t.Util.unbindEvent(e, this.event, this.publish) : void 0
            },
            routine: function(t, e) {
                var i, o, n, r, s, a, c;
                if ("INPUT" === t.tagName && "radio" === t.type) return t.setAttribute("value", e);
                if (null != window.jQuery) {
                    if (t = jQuery(t), (null != e ? e.toString() : void 0) !== (null != (r = t.val()) ? r.toString() : void 0)) return t.val(null != e ? e : "")
                } else if ("select-multiple" === t.type) {
                    if (null != e) {
                        for (c = [], o = 0, n = t.length; n > o; o++) i = t[o], c.push(i.selected = (s = i.value, l.call(e, s) >= 0));
                        return c
                    }
                } else if ((null != e ? e.toString() : void 0) !== (null != (a = t.value) ? a.toString() : void 0)) return t.value = null != e ? e : ""
            }
        }, t["public"].binders["if"] = {
            block: !0,
            priority: 4e3,
            bind: function(t) {
                var e, i;
                return null == this.marker ? (e = [this.view.prefix, this.type].join("-").replace("--", "-"), i = t.getAttribute(e), this.marker = document.createComment(" rivets: " + this.type + " " + i + " "), this.bound = !1, t.removeAttribute(e), t.parentNode.insertBefore(this.marker, t), t.parentNode.removeChild(t)) : void 0
            },
            unbind: function() {
                var t;
                return null != (t = this.nested) ? t.unbind() : void 0
            },
            routine: function(e, i) {
                var o, n, r, s;
                if (!!i == !this.bound) {
                    if (i) {
                        r = {}, s = this.view.models;
                        for (o in s) n = s[o], r[o] = n;
                        return (this.nested || (this.nested = new t.View(e, r, this.view.options()))).bind(), this.marker.parentNode.insertBefore(e, this.marker.nextSibling), this.bound = !0
                    }
                    return e.parentNode.removeChild(e), this.nested.unbind(), this.bound = !1
                }
            },
            update: function(t) {
                var e;
                return null != (e = this.nested) ? e.update(t) : void 0
            }
        }, t["public"].binders.unless = {
            block: !0,
            priority: 4e3,
            bind: function(e) {
                return t["public"].binders["if"].bind.call(this, e)
            },
            unbind: function() {
                return t["public"].binders["if"].unbind.call(this)
            },
            routine: function(e, i) {
                return t["public"].binders["if"].routine.call(this, e, !i)
            },
            update: function(e) {
                return t["public"].binders["if"].update.call(this, e)
            }
        }, t["public"].binders["on-*"] = {
            "function": !0,
            priority: 1e3,
            unbind: function(e) {
                return this.handler ? t.Util.unbindEvent(e, this.args[0], this.handler) : void 0
            },
            routine: function(e, i) {
                return this.handler && t.Util.unbindEvent(e, this.args[0], this.handler), t.Util.bindEvent(e, this.args[0], this.handler = this.eventHandler(i))
            }
        }, t["public"].binders["each-*"] = {
            block: !0,
            priority: 4e3,
            bind: function(t) {
                var e, i, o, n, r;
                if (null == this.marker) e = [this.view.prefix, this.type].join("-").replace("--", "-"), this.marker = document.createComment(" rivets: " + this.type + " "), this.iterated = [], t.removeAttribute(e), t.parentNode.insertBefore(this.marker, t), t.parentNode.removeChild(t);
                else
                    for (r = this.iterated, o = 0, n = r.length; n > o; o++) i = r[o], i.bind()
            },
            unbind: function() {
                var t, e, i, o, n;
                if (null != this.iterated) {
                    for (o = this.iterated, n = [], e = 0, i = o.length; i > e; e++) t = o[e], n.push(t.unbind());
                    return n
                }
            },
            routine: function(e, i) {
                var o, n, r, s, a, l, c, u, d, p, h, m, f, y, g, v, w, _, b, k, C;
                if (c = this.args[0], i = i || [], this.iterated.length > i.length)
                    for (_ = Array(this.iterated.length - i.length), m = 0, g = _.length; g > m; m++) r = _[m], h = this.iterated.pop(), h.unbind(), this.marker.parentNode.removeChild(h.els[0]);
                for (s = f = 0, v = i.length; v > f; s = ++f)
                    if (l = i[s], n = {
                            index: s
                        }, n[c] = l, null == this.iterated[s]) {
                        b = this.view.models;
                        for (a in b) l = b[a], null == n[a] && (n[a] = l);
                        d = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker, u = this.view.options(), u.preloadData = !0, p = e.cloneNode(!0), h = new t.View(p, n, u), h.bind(), this.iterated.push(h), this.marker.parentNode.insertBefore(p, d.nextSibling)
                    } else this.iterated[s].models[c] !== l && this.iterated[s].update(n);
                if ("OPTION" === e.nodeName) {
                    for (k = this.view.bindings, C = [], y = 0, w = k.length; w > y; y++) o = k[y], C.push(o.el === this.marker.parentNode && "value" === o.type ? o.sync() : void 0);
                    return C
                }
            },
            update: function(t) {
                var e, i, o, n, r, s, a, l;
                e = {};
                for (i in t) o = t[i], i !== this.args[0] && (e[i] = o);
                for (a = this.iterated, l = [], r = 0, s = a.length; s > r; r++) n = a[r], l.push(n.update(e));
                return l
            }
        }, t["public"].binders["class-*"] = function(t, e) {
            var i;
            return i = " " + t.className + " ", !e == (-1 !== i.indexOf(" " + this.args[0] + " ")) ? t.className = e ? "" + t.className + " " + this.args[0] : i.replace(" " + this.args[0] + " ", " ").trim() : void 0
        }, t["public"].binders["*"] = function(t, e) {
            return null != e ? t.setAttribute(this.type, e) : t.removeAttribute(this.type)
        }, t["public"].adapters["."] = {
            id: "_rv",
            counter: 0,
            weakmap: {},
            weakReference: function(t) {
                var e, i, o;
                return t.hasOwnProperty(this.id) || (e = this.counter++, Object.defineProperty(t, this.id, {
                    value: e
                })), (i = this.weakmap)[o = t[this.id]] || (i[o] = {
                    callbacks: {}
                })
            },
            cleanupWeakReference: function(t, e) {
                return Object.keys(t.callbacks).length || t.pointers && Object.keys(t.pointers).length ? void 0 : delete this.weakmap[e]
            },
            stubFunction: function(t, e) {
                var i, o, n;
                return o = t[e], i = this.weakReference(t), n = this.weakmap, t[e] = function() {
                    var e, r, s, a, l, c, u, d, p, h;
                    a = o.apply(t, arguments), u = i.pointers;
                    for (s in u)
                        for (r = u[s], h = null != (d = null != (p = n[s]) ? p.callbacks[r] : void 0) ? d : [], l = 0, c = h.length; c > l; l++)(e = h[l])();
                    return a
                }
            },
            observeMutations: function(t, e, i) {
                var o, n, r, s, a, c;
                if (Array.isArray(t)) {
                    if (r = this.weakReference(t), null == r.pointers)
                        for (r.pointers = {}, n = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"], a = 0, c = n.length; c > a; a++) o = n[a], this.stubFunction(t, o);
                    if (null == (s = r.pointers)[e] && (s[e] = []), l.call(r.pointers[e], i) < 0) return r.pointers[e].push(i)
                }
            },
            unobserveMutations: function(t, e, i) {
                var o, n, r;
                return Array.isArray(t) && null != t[this.id] && (n = this.weakmap[t[this.id]]) && (r = n.pointers[e]) ? ((o = r.indexOf(i)) >= 0 && r.splice(o, 1), r.length || delete n.pointers[e], this.cleanupWeakReference(n, t[this.id])) : void 0
            },
            observe: function(t, e, i) {
                var o, n, r;
                return o = this.weakReference(t).callbacks, null == o[e] && (o[e] = [], n = Object.getOwnPropertyDescriptor(t, e), (null != n ? n.get : void 0) || (null != n ? n.set : void 0) || (r = t[e], Object.defineProperty(t, e, {
                    enumerable: !0,
                    get: function() {
                        return r
                    },
                    set: function(n) {
                        return function(s) {
                            var a, c, u, d;
                            if (s !== r && (n.unobserveMutations(r, t[n.id], e), r = s, a = n.weakmap[t[n.id]])) {
                                if (o = a.callbacks, o[e])
                                    for (d = o[e].slice(), c = 0, u = d.length; u > c; c++) i = d[c], l.call(o[e], i) >= 0 && i();
                                return n.observeMutations(s, t[n.id], e)
                            }
                        }
                    }(this)
                }))), l.call(o[e], i) < 0 && o[e].push(i), this.observeMutations(t[e], t[this.id], e)
            },
            unobserve: function(t, e, i) {
                var o, n, r;
                return (r = this.weakmap[t[this.id]]) && (o = r.callbacks[e]) ? ((n = o.indexOf(i)) >= 0 && (o.splice(n, 1), o.length || delete r.callbacks[e]), this.unobserveMutations(t[e], t[this.id], e), this.cleanupWeakReference(r, t[this.id])) : void 0
            },
            get: function(t, e) {
                return t[e]
            },
            set: function(t, e, i) {
                return t[e] = i
            }
        }, t.factory = function(e) {
            return t.sightglass = e, t["public"]._ = t, t["public"]
        }, "object" == typeof("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = t.factory(require("sightglass")) : "function" == typeof define && define.amd ? define(["sightglass"], function(e) {
            return this.rivets = t.factory(e)
        }) : this.rivets = t.factory(sightglass)
    }.call(this),
    function() {
        var t, e, i, o, n, r, s = function(t, e) {
            return function() {
                return t.apply(e, arguments)
            }
        };
        e = function() {
            function t() {
                this.update = s(this.update, this)
            }
            return t.prototype.update = function(t) {
                var e, i, n;
                for (i in t) n = t[i], "items" !== i && (this[i] = n);
                return this.items = function() {
                    var i, n, r, s;
                    for (r = t.items, s = [], i = 0, n = r.length; n > i; i++) e = r[i], s.push(new o(e));
                    return s
                }()
            }, t
        }(), o = function() {
            function t(t) {
                this.propertyArray = s(this.propertyArray, this), this.update = s(this.update, this), this.update(t)
            }
            return t.prototype.update = function(t) {
                var e, o;
                for (e in t) o = t[e], "properties" !== e && (this[e] = o);
                return this.properties = i.Utils.extend({}, t.properties)
            }, t.prototype.propertyArray = function() {
                var t, e, i, o;
                i = this.properties, o = [];
                for (t in i) e = i[t], o.push({
                    name: t,
                    value: e
                });
                return o
            }, t
        }(), i = {
            settings: {
                debug: !1,
                dataAPI: !0,
                requestBodyClass: null,
                rivetsModels: {},
                currency: null,
                moneyFormat: null,
                moneyWithCurrencyFormat: null,
                weightUnit: "g",
                weightPrecision: 0
            },
            cart: new e
        }, i.init = function(t, e) {
            return null == e && (e = {}), i.configure(e), i.Utils.log("Initialising CartJS."), i.cart.update(t), i.settings.dataAPI && (i.Utils.log('"dataAPI" setting is true, initialising Data API.'), i.Data.init()), i.settings.requestBodyClass && (i.Utils.log('"requestBodyClass" set, adding event listeners.'), $(document).on("cart.requestStarted", function() {
                return $("body").addClass(i.settings.requestBodyClass)
            }), $(document).on("cart.requestComplete", function() {
                return $("body").removeClass(i.settings.requestBodyClass)
            })), i.Rivets.init()
        }, i.configure = function(t) {
            return null == t && (t = {}), i.Utils.extend(i.settings, t)
        }, null == window.console && (window.console = {}, window.console.log = function() {}), i.Utils = {
            log: function() {
                return i.Utils.console(console.log, arguments)
            },
            error: function() {
                return i.Utils.console(console.error, arguments)
            },
            console: function(t, e) {
                return i.settings.debug && "undefined" != typeof console && null !== console ? (e = Array.prototype.slice.call(e), e.unshift("[CartJS]:"), t.apply(console, e)) : void 0
            },
            wrapKeys: function(t, e, i) {
                var o, n, r;
                null == e && (e = "properties"), r = {};
                for (o in t) n = t[o], r["" + e + "[" + o + "]"] = null != i ? i : n;
                return r
            },
            unwrapKeys: function(t, e, i) {
                var o, n, r, s;
                null == e && (e = "properties"), n = {};
                for (o in t) s = t[o], r = o.replace("" + e + "[", "").replace("]", ""), n[r] = null != i ? i : s;
                return n
            },
            extend: function(t, e) {
                var i, o;
                for (i in e) o = e[i], t[i] = o;
                return t
            },
            clone: function(t) {
                var e, i;
                if (null == t || "object" != typeof t) return t;
                i = new t.constructor;
                for (e in t) i[e] = clone(t[e]);
                return i
            },
            isArray: Array.isArray || function(t) {
                return "[object Array]" === {}.toString.call(t)
            },
            ensureArray: function(t) {
                return i.Utils.isArray(t) ? t : null != t ? [t] : []
            },
            formatMoney: function(t, e, o, n) {
                var r, s;
                return null == n && (n = ""), n || (n = i.settings.currency), null != window.Currency && n !== i.settings.currency && (t = Currency.convert(t, i.settings.currency, n), null != (null != (r = window.Currency) ? r.moneyFormats : void 0) && n in window.Currency.moneyFormats && (e = window.Currency.moneyFormats[n][o])), null != (null != (s = window.Shopify) ? s.formatMoney : void 0) ? Shopify.formatMoney(t, e) : t
            },
            getSizedImageUrl: function(t, e) {
                var i, o;
                return null != (null != (i = window.Shopify) && null != (o = i.Image) ? o.getSizedImageUrl : void 0) ? t ? Shopify.Image.getSizedImageUrl(t, e) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", e).replace("-_", "-") : t ? t : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
            }
        }, r = [], n = !1, i.Queue = {
            add: function(t, e, o) {
                var s;
                return null == o && (o = {}), s = {
                    url: t,
                    data: e,
                    type: o.type || "POST",
                    dataType: o.dataType || "json",
                    success: i.Utils.ensureArray(o.success),
                    error: i.Utils.ensureArray(o.error),
                    complete: i.Utils.ensureArray(o.complete)
                }, o.updateCart && s.success.push(i.cart.update), r.push(s), n ? void 0 : (jQuery(document).trigger("cart.requestStarted", [i.cart]), i.Queue.process())
            },
            process: function() {
                var t;
                return r.length ? (n = !0, t = r.shift(), t.complete = i.Queue.process, jQuery.ajax(t)) : (n = !1, void jQuery(document).trigger("cart.requestComplete", [i.cart]))
            }
        }, i.Core = {
            getCart: function(t) {
                return null == t && (t = {}), t.type = "GET", t.updateCart = !0, i.Queue.add("/cart.js", {}, t)
            },
            addItem: function(t, e, o, n) {
                var r;
                return null == e && (e = 1), null == o && (o = {}), null == n && (n = {}), r = i.Utils.wrapKeys(o), r.id = t, r.quantity = e, i.Queue.add("/cart/add.js", r, n), i.Core.getCart()
            },
            updateItem: function(t, e, o, n) {
                var r;
                return null == o && (o = {}), null == n && (n = {}), r = i.Utils.wrapKeys(o), r.line = t, null != e && (r.quantity = e), n.updateCart = !0, i.Queue.add("/cart/change.js", r, n)
            },
            removeItem: function(t, e) {
                return null == e && (e = {}), i.Core.updateItem(t, 0, {}, e)
            },
            updateItemById: function(t, e, o, n) {
                var r;
                return null == o && (o = {}), null == n && (n = {}), r = i.Utils.wrapKeys(o), r.id = t, null != e && (r.quantity = e), n.updateCart = !0, i.Queue.add("/cart/change.js", r, n)
            },
            updateItemQuantitiesById: function(t, e) {
                return null == t && (t = {}), null == e && (e = {}), e.updateCart = !0, i.Queue.add("/cart/update.js", {
                    updates: t
                }, e)
            },
            removeItemById: function(t, e) {
                var o;
                return null == e && (e = {}), o = {
                    id: t,
                    quantity: 0
                }, e.updateCart = !0, i.Queue.add("/cart/change.js", o, e)
            },
            clear: function(t) {
                return null == t && (t = {}), t.updateCart = !0, i.Queue.add("/cart/clear.js", {}, t)
            },
            getAttribute: function(t, e) {
                return t in i.cart.attributes ? i.cart.attributes[t] : e
            },
            setAttribute: function(t, e, o) {
                var n;
                return null == o && (o = {}), n = {}, n[t] = e, i.Core.setAttributes(n, o)
            },
            getAttributes: function() {
                return i.cart.attributes
            },
            setAttributes: function(t, e) {
                return null == t && (t = {}), null == e && (e = {}), e.updateCart = !0, i.Queue.add("/cart/update.js", i.Utils.wrapKeys(t, "attributes"), e)
            },
            clearAttributes: function(t) {
                return null == t && (t = {}), t.updateCart = !0, i.Queue.add("/cart/update.js", i.Utils.wrapKeys(i.Core.getAttributes(), "attributes", ""), t)
            },
            getNote: function() {
                return i.cart.note
            },
            setNote: function(t, e) {
                return null == e && (e = {}), e.updateCart = !0, i.Queue.add("/cart/update.js", {
                    note: t
                }, e)
            }
        }, t = jQuery(document), i.Data = {
            init: function() {
                return i.Data.setEventListeners("on"), i.Data.render(null, i.cart)
            },
            destroy: function() {
                return i.Data.setEventListeners("off")
            },
            setEventListeners: function(e) {
                return t[e]("click", "[data-cart-add]", i.Data.add), t[e]("click", "[data-cart-remove]", i.Data.remove), t[e]("click", "[data-cart-remove-id]", i.Data.removeById), t[e]("click", "[data-cart-update]", i.Data.update), t[e]("click", "[data-cart-update-id]", i.Data.updateById), t[e]("click", "[data-cart-clear]", i.Data.clear), t[e]("change", "[data-cart-toggle]", i.Data.toggle), t[e]("change", "[data-cart-toggle-attribute]", i.Data.toggleAttribute), t[e]("submit", "[data-cart-submit]", i.Data.submit), t[e]("cart.requestComplete", i.Data.render)
            },
            add: function(t) {
                var e;
                return t.preventDefault(), e = jQuery(this), i.Core.addItem(e.attr("data-cart-add"), e.attr("data-cart-quantity"))
            },
            remove: function(t) {
                var e;
                return t.preventDefault(), e = jQuery(this), i.Core.removeItem(e.attr("data-cart-remove"))
            },
            removeById: function(t) {
                var e;
                return t.preventDefault(), e = jQuery(this), i.Core.removeItemById(e.attr("data-cart-remove-id"))
            },
            update: function(t) {
                var e;
                return t.preventDefault(), e = jQuery(this), i.Core.updateItem(e.attr("data-cart-update"), e.attr("data-cart-quantity"))
            },
            updateById: function(t) {
                var e;
                return t.preventDefault(), e = jQuery(this), i.Core.updateItemById(e.attr("data-cart-update-id"), e.attr("data-cart-quantity"))
            },
            clear: function(t) {
                return t.preventDefault(), i.Core.clear()
            },
            toggle: function() {
                var t, e;
                return t = jQuery(this), e = t.attr("data-cart-toggle"), t.is(":checked") ? i.Core.addItem(e) : i.Core.removeItemById(e)
            },
            toggleAttribute: function() {
                var t, e;
                return t = jQuery(this), e = t.attr("data-cart-toggle-attribute"), i.Core.setAttribute(e, t.is(":checked") ? "Yes" : "")
            },
            submit: function(t) {
                var e, o, n, r;
                return t.preventDefault(), e = jQuery(this).serializeArray(), o = void 0, r = void 0, n = {}, jQuery.each(e, function(t, e) {
                    return "id" === e.name ? o = e.value : "quantity" === e.name ? r = e.value : n[e.name] = e.value
                }), i.Core.addItem(o, r, i.Utils.unwrapKeys(n))
            },
            render: function(t, e) {
                var o;
                return o = {
                    item_count: e.item_count,
                    total_price: e.total_price,
                    total_price_money: i.Utils.formatMoney(e.total_price, i.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                    total_price_money_with_currency: i.Utils.formatMoney(e.total_price, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
                }, jQuery("[data-cart-render]").each(function() {
                    var t;
                    return t = jQuery(this), t.html(o[t.attr("data-cart-render")])
                })
            }
        }, "rivets" in window ? (i.Rivets = {
            model: null,
            boundViews: [],
            init: function() {
                return i.Rivets.bindViews(), null != i.IE8 ? i.IE8.init() : void 0
            },
            destroy: function() {
                return i.Rivets.unbindViews(), null != i.IE8 ? i.IE8.destroy() : void 0
            },
            bindViews: function() {
                return i.Utils.log("Rivets.js is present, binding views."), i.Rivets.unbindViews(), i.Rivets.model = i.Utils.extend({
                    cart: i.cart
                }, i.settings.rivetsModels), null != window.Currency && (i.Rivets.model.Currency = window.Currency), jQuery("[data-cart-view]").each(function() {
                    var t;
                    return t = rivets.bind(jQuery(this), i.Rivets.model), i.Rivets.boundViews.push(t)
                })
            },
            unbindViews: function() {
                var t, e, o, n;
                for (n = i.Rivets.boundViews, e = 0, o = n.length; o > e; e++) t = n[e], t.unbind();
                return i.Rivets.boundViews = []
            }
        }, rivets.formatters.eq = function(t, e) {
            return t === e
        }, rivets.formatters.lt = function(t, e) {
            return e > t
        }, rivets.formatters.gt = function(t, e) {
            return t > e
        }, rivets.formatters.not = function(t) {
            return !t
        }, rivets.formatters.empty = function(t) {
            return !t.length
        }, rivets.formatters.plus = function(t, e) {
            return parseInt(t) + parseInt(e)
        }, rivets.formatters.minus = function(t, e) {
            return parseInt(t) - parseInt(e)
        }, rivets.formatters.prepend = function(t, e) {
            return e + t
        }, rivets.formatters.append = function(t, e) {
            return t + e
        }, rivets.formatters.money = function(t, e) {
            return i.Utils.formatMoney(t, i.settings.moneyFormat, "money_format", e)
        }, rivets.formatters.money_with_currency = function(t, e) {
            return i.Utils.formatMoney(t, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", e)
        }, rivets.formatters.weight = function(t) {
            switch (i.settings.weightUnit) {
                case "kg":
                    return (t / 1e3).toFixed(i.settings.weightPrecision);
                case "oz":
                    return (.035274 * t).toFixed(i.settings.weightPrecision);
                case "lb":
                    return (.00220462 * t).toFixed(i.settings.weightPrecision);
                default:
                    return t.toFixed(i.settings.weightPrecision)
            }
        }, rivets.formatters.weight_with_unit = function(t) {
            return rivets.formatters.weight(t) + i.settings.weightUnit
        }, rivets.formatters.product_image_size = function(t, e) {
            return i.Utils.getSizedImageUrl(t, e)
        }, rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency, rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit, rivets.formatters.productImageSize = rivets.formatters.product_image_size) : i.Rivets = {
            init: function() {},
            destroy: function() {}
        }, i.factory = function(t) {
            return t.init = i.init, t.configure = i.configure, t.cart = i.cart, t.settings = i.settings, t.getCart = i.Core.getCart, t.addItem = i.Core.addItem, t.updateItem = i.Core.updateItem, t.updateItemById = i.Core.updateItemById, t.updateItemQuantitiesById = i.Core.updateItemQuantitiesById, t.removeItem = i.Core.removeItem, t.removeItemById = i.Core.removeItemById, t.clear = i.Core.clear, t.getAttribute = i.Core.getAttribute, t.setAttribute = i.Core.setAttribute, t.getAttributes = i.Core.getAttributes, t.setAttributes = i.Core.setAttributes, t.clearAttributes = i.Core.clearAttributes, t.getNote = i.Core.getNote, t.setNote = i.Core.setNote, t.render = i.Data.render
        }, "object" == typeof exports ? i.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(t) {
            return i.factory(this.CartJS = t), t
        }) : i.factory(this.CartJS = {})
    }.call(this),
    function(t, e) {
        "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? module.exports = e() : t.RouterRouter = e()
    }(this, function() {
        "use strict";
        var t = /[\-{}\[\]+?.,\\\^$|#\s]/g,
            e = /(\(\?)?:\w+/g,
            i = /\((.*?)\)/g,
            o = /\*\w+/g,
            n = /^[#\/]|\s+$/g,
            r = /\/$/,
            s = function(t, e) {
                return Object.prototype.toString.call(t) === "[object " + e + "]"
            },
            a = function(t) {
                this.options = "undefined" != typeof t ? t : {}, this.options.routes && (this.routes = this.options.routes), this.location = window.location, this._bindRoutes()
            };
        return a.prototype = {
            _bindRoutes: function() {
                if (this.routes)
                    for (var t, e = Object.keys(this.routes);
                        "undefined" != typeof(t = e.pop());) this.route(t, this.routes[t])
            },
            _extractParameters: function(t, e) {
                var i = t.exec(e).slice(1);
                return i.map(function(t) {
                    return t ? decodeURIComponent(t) : null
                })
            },
            _getFragment: function(t) {
                return t.replace(n, "").replace(r, "")
            },
            _routeToRegExp: function(n) {
                return n = n.replace(t, "\\$&").replace(i, "(?:$1)?").replace(e, function(t, e) {
                    return e ? t : "([^/?]+)"
                }).replace(o, "([^?]*?)"), new RegExp("^" + n + "(?:\\?([\\s\\S]*))?$")
            },
            route: function(t, e, i) {
                s(t, "RegExp") || (t = this._routeToRegExp(t)), s(e, "Function") && (i = e, e = ""), i || (i = this.options[e]);
                var o = this._getFragment(this.location.pathname);
                if (t.test(o)) {
                    var n = this._extractParameters(t, o);
                    s(i, "Function") && i.apply(this, n)
                }
                return this
            }
        }, a
    });
var Siutsur = function() {
    return {
        load: function(t, e, i) {
            this.c = e, this.ec = i, $("<script />", {
                src: "//cdn.syndication.twimg.com/widgets/timelines/" + t + "?&lang=en&callback=Siutsur.callback&suppress_response_codes=true&_=" + Math.random()
            }).appendTo(document.head)
        },
        callback: function(t) {
            if (t.headers && 200 == t.headers.status) {
                var e = $(t.body),
                    i = [],
                    o = e.find(".timeline-Tweet");
                $.each(o, function(t, e) {
                    var o = $(e),
                        n = o.find(".timeline-Tweet-metadata"),
                        r = n.find(".dt-updated"),
                        s = o.find(".timeline-Tweet-text"),
                        a = o.find(".timeline-Tweet-author"),
                        l = {
                            id: parseInt(o.data("tweet-id"), 10),
                            permalink: n.find(".timeline-Tweet-timestamp").attr("href"),
                            published: {
                                datetime: r.attr("datetime"),
                                label: r.attr("aria-label"),
                                title: r.attr("title")
                            },
                            title: {
                                regular: s.html(),
                                plain: s.text()
                            },
                            user: {
                                avatar: {
                                    bigger: a.find(".Avatar").attr("data-src-2x"),
                                    normal: a.find(".Avatar").attr("data-src-1x")
                                },
                                link: a.find(".TweetAuthor-link").attr("href"),
                                name: a.find(".TweetAuthor-name").text(),
                                nickname: a.find(".TweetAuthor-screenName").attr("title")
                            }
                        };
                    i.push(l)
                }), this.c && this.c.call(this, i)
            } else this.ec && this.ec.call(this)
        }
    }
}();
! function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    var e = window.Slick || {};
    e = function() {
        function e(e, o) {
            var n, r = this;
            r.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: t(e),
                appendDots: t(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(t, e) {
                    return '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' + (e + 1) + "</button>"
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, r.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, t.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.hidden = "hidden", r.paused = !1, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = t(e), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, n = t(e).data("slick") || {}, r.options = t.extend({}, r.defaults, n, o), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, "undefined" != typeof document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = t.proxy(r.autoPlay, r), r.autoPlayClear = t.proxy(r.autoPlayClear, r), r.changeSlide = t.proxy(r.changeSlide, r), r.clickHandler = t.proxy(r.clickHandler, r), r.selectHandler = t.proxy(r.selectHandler, r), r.setPosition = t.proxy(r.setPosition, r), r.swipeHandler = t.proxy(r.swipeHandler, r), r.dragHandler = t.proxy(r.dragHandler, r), r.keyHandler = t.proxy(r.keyHandler, r), r.autoPlayIterator = t.proxy(r.autoPlayIterator, r), r.instanceUid = i++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0), r.checkResponsive(!0)
        }
        var i = 0;
        return e
    }(), e.prototype.addSlide = e.prototype.slickAdd = function(e, i, o) {
        var n = this;
        if ("boolean" == typeof i) o = i, i = null;
        else if (0 > i || i >= n.slideCount) return !1;
        n.unload(), "number" == typeof i ? 0 === i && 0 === n.$slides.length ? t(e).appendTo(n.$slideTrack) : o ? t(e).insertBefore(n.$slides.eq(i)) : t(e).insertAfter(n.$slides.eq(i)) : o === !0 ? t(e).prependTo(n.$slideTrack) : t(e).appendTo(n.$slideTrack), n.$slides = n.$slideTrack.children(this.options.slide), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.append(n.$slides), n.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e)
        }), n.$slidesCache = n.$slides, n.reinit()
    }, e.prototype.animateHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && t.options.adaptiveHeight === !0 && t.options.vertical === !1) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({
                height: e
            }, t.options.speed)
        }
    }, e.prototype.animateSlide = function(e, i) {
        var o = {},
            n = this;
        n.animateHeight(), n.options.rtl === !0 && n.options.vertical === !1 && (e = -e), n.transformsEnabled === !1 ? n.options.vertical === !1 ? n.$slideTrack.animate({
            left: e
        }, n.options.speed, n.options.easing, i) : n.$slideTrack.animate({
            top: e
        }, n.options.speed, n.options.easing, i) : n.cssTransitions === !1 ? (n.options.rtl === !0 && (n.currentLeft = -n.currentLeft), t({
            animStart: n.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: n.options.speed,
            easing: n.options.easing,
            step: function(t) {
                t = Math.ceil(t), n.options.vertical === !1 ? (o[n.animType] = "translate(" + t + "px, 0px)", n.$slideTrack.css(o)) : (o[n.animType] = "translate(0px," + t + "px)", n.$slideTrack.css(o))
            },
            complete: function() {
                i && i.call()
            }
        })) : (n.applyTransition(), e = Math.ceil(e), o[n.animType] = n.options.vertical === !1 ? "translate3d(" + e + "px, 0px, 0px)" : "translate3d(0px," + e + "px, 0px)", n.$slideTrack.css(o), i && setTimeout(function() {
            n.disableTransition(), i.call()
        }, n.options.speed))
    }, e.prototype.asNavFor = function(e) {
        var i = this,
            o = i.options.asNavFor;
        o && null !== o && (o = t(o).not(i.$slider)), null !== o && "object" == typeof o && o.each(function() {
            var i = t(this).slick("getSlick");
            i.unslicked || i.slideHandler(e, !0)
        })
    }, e.prototype.applyTransition = function(t) {
        var e = this,
            i = {};
        i[e.transitionType] = e.options.fade === !1 ? e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : "opacity " + e.options.speed + "ms " + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }, e.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayTimer && clearInterval(t.autoPlayTimer), t.slideCount > t.options.slidesToShow && t.paused !== !0 && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }, e.prototype.autoPlayClear = function() {
        var t = this;
        t.autoPlayTimer && clearInterval(t.autoPlayTimer)
    }, e.prototype.autoPlayIterator = function() {
        var t = this;
        t.options.infinite === !1 ? 1 === t.direction ? (t.currentSlide + 1 === t.slideCount - 1 && (t.direction = 0),
            t.slideHandler(t.currentSlide + t.options.slidesToScroll)) : (t.currentSlide - 1 === 0 && (t.direction = 1), t.slideHandler(t.currentSlide - t.options.slidesToScroll)) : t.slideHandler(t.currentSlide + t.options.slidesToScroll)
    }, e.prototype.buildArrows = function() {
        var e = this;
        e.options.arrows === !0 && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, e.prototype.buildDots = function() {
        var e, i, o = this;
        if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
            for (i = '<ul class="' + o.options.dotsClass + '">', e = 0; e <= o.getDotCount(); e += 1) i += "<li>" + o.options.customPaging.call(this, o, e) + "</li>";
            i += "</ul>", o.$dots = t(i).appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
        }
    }, e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, i) {
            t(i).attr("data-slick-index", e).data("originalStyling", t(i).attr("style") || "")
        }), e.$slidesCache = e.$slides, e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), (e.options.centerMode === !0 || e.options.swipeToSlide === !0) && (e.options.slidesToScroll = 1), t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass("draggable")
    }, e.prototype.buildRows = function() {
        var t, e, i, o, n, r, s, a = this;
        if (o = document.createDocumentFragment(), r = a.$slider.children(), a.options.rows > 1) {
            for (s = a.options.slidesPerRow * a.options.rows, n = Math.ceil(r.length / s), t = 0; n > t; t++) {
                var l = document.createElement("div");
                for (e = 0; e < a.options.rows; e++) {
                    var c = document.createElement("div");
                    for (i = 0; i < a.options.slidesPerRow; i++) {
                        var u = t * s + (e * a.options.slidesPerRow + i);
                        r.get(u) && c.appendChild(r.get(u))
                    }
                    l.appendChild(c)
                }
                o.appendChild(l)
            }
            a.$slider.html(o), a.$slider.children().children().children().css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, e.prototype.checkResponsive = function(e, i) {
        var o, n, r, s = this,
            a = !1,
            l = s.$slider.width(),
            c = window.innerWidth || t(window).width();
        if ("window" === s.respondTo ? r = c : "slider" === s.respondTo ? r = l : "min" === s.respondTo && (r = Math.min(c, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
            n = null;
            for (o in s.breakpoints) s.breakpoints.hasOwnProperty(o) && (s.originalSettings.mobileFirst === !1 ? r < s.breakpoints[o] && (n = s.breakpoints[o]) : r > s.breakpoints[o] && (n = s.breakpoints[o]));
            null !== n ? null !== s.activeBreakpoint ? (n !== s.activeBreakpoint || i) && (s.activeBreakpoint = n, "unslick" === s.breakpointSettings[n] ? s.unslick(n) : (s.options = t.extend({}, s.originalSettings, s.breakpointSettings[n]), e === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(e)), a = n) : (s.activeBreakpoint = n, "unslick" === s.breakpointSettings[n] ? s.unslick(n) : (s.options = t.extend({}, s.originalSettings, s.breakpointSettings[n]), e === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(e)), a = n) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, e === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(e), a = n), e || a === !1 || s.$slider.trigger("breakpoint", [s, a])
        }
    }, e.prototype.changeSlide = function(e, i) {
        var o, n, r, s = this,
            a = t(e.target);
        switch (a.is("a") && e.preventDefault(), a.is("li") || (a = a.closest("li")), r = s.slideCount % s.options.slidesToScroll !== 0, o = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, e.data.message) {
            case "previous":
                n = 0 === o ? s.options.slidesToScroll : s.options.slidesToShow - o, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - n, !1, i);
                break;
            case "next":
                n = 0 === o ? s.options.slidesToScroll : o, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + n, !1, i);
                break;
            case "index":
                var l = 0 === e.data.index ? 0 : e.data.index || a.index() * s.options.slidesToScroll;
                s.slideHandler(s.checkNavigable(l), !1, i), a.children().trigger("focus");
                break;
            default:
                return
        }
    }, e.prototype.checkNavigable = function(t) {
        var e, i, o = this;
        if (e = o.getNavigableIndexes(), i = 0, t > e[e.length - 1]) t = e[e.length - 1];
        else
            for (var n in e) {
                if (t < e[n]) {
                    t = i;
                    break
                }
                i = e[n]
            }
        return t
    }, e.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (t("li", e.$dots).off("click.slick", e.changeSlide), e.options.pauseOnDotsHover === !0 && e.options.autoplay === !0 && t("li", e.$dots).off("mouseenter.slick", t.proxy(e.setPaused, e, !0)).off("mouseleave.slick", t.proxy(e.setPaused, e, !1))), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), t(document).off(e.visibilityChange, e.visibility), e.$list.off("mouseenter.slick", t.proxy(e.setPaused, e, !0)), e.$list.off("mouseleave.slick", t.proxy(e.setPaused, e, !1)), e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && t(e.$slideTrack).children().off("click.slick", e.selectHandler), t(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), t(window).off("resize.slick.slick-" + e.instanceUid, e.resize), t("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
    }, e.prototype.cleanUpRows = function() {
        var t, e = this;
        e.options.rows > 1 && (t = e.$slides.children().children(), t.removeAttr("style"), e.$slider.html(t))
    }, e.prototype.clickHandler = function(t) {
        var e = this;
        e.shouldClick === !1 && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault())
    }, e.prototype.destroy = function(e) {
        var i = this;
        i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), t(".slick-cloned", i.$slider).detach(), i.$dots && i.$dots.remove(), i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            t(this).attr("style", t(this).data("originalStyling"))
        }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), i.$slider.removeClass("slick-initialized"), i.unslicked = !0, e || i.$slider.trigger("destroy", [i])
    }, e.prototype.disableTransition = function(t) {
        var e = this,
            i = {};
        i[e.transitionType] = "", e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }, e.prototype.fadeSlide = function(t, e) {
        var i = this;
        i.cssTransitions === !1 ? (i.$slides.eq(t).css({
            zIndex: i.options.zIndex
        }), i.$slides.eq(t).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t), i.$slides.eq(t).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }), e && setTimeout(function() {
            i.disableTransition(t), e.call()
        }, i.options.speed))
    }, e.prototype.fadeSlideOut = function(t) {
        var e = this;
        e.cssTransitions === !1 ? e.$slides.eq(t).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(t), e.$slides.eq(t).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }, e.prototype.filterSlides = e.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit())
    }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        var t = this;
        return t.currentSlide
    }, e.prototype.getDotCount = function() {
        var t = this,
            e = 0,
            i = 0,
            o = 0;
        if (t.options.infinite === !0)
            for (; e < t.slideCount;) ++o, e = i + t.options.slidesToShow, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else if (t.options.centerMode === !0) o = t.slideCount;
        else
            for (; e < t.slideCount;) ++o, e = i + t.options.slidesToShow, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        return o - 1
    }, e.prototype.getLeft = function(t) {
        var e, i, o, n = this,
            r = 0;
        return n.slideOffset = 0, i = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, r = i * n.options.slidesToShow * -1), n.slideCount % n.options.slidesToScroll !== 0 && t + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (t > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (t - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (t - n.slideCount)) * i * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * i * -1))) : t + n.options.slidesToShow > n.slideCount && (n.slideOffset = (t + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (t + n.options.slidesToShow - n.slideCount) * i), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? t * n.slideWidth * -1 + n.slideOffset : t * i * -1 + r, n.options.variableWidth === !0 && (o = n.$slideTrack.children(".slick-slide").eq(n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? t : t + n.options.slidesToShow), e = o[0] ? -1 * o[0].offsetLeft : 0, n.options.centerMode === !0 && (o = n.$slideTrack.children(".slick-slide").eq(n.options.infinite === !1 ? t : t + n.options.slidesToShow + 1), e = o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
    }, e.prototype.getOption = e.prototype.slickGetOption = function(t) {
        var e = this;
        return e.options[t]
    }, e.prototype.getNavigableIndexes = function() {
        var t, e = this,
            i = 0,
            o = 0,
            n = [];
        for (e.options.infinite === !1 ? t = e.slideCount : (i = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, t = 2 * e.slideCount); t > i;) n.push(i), i = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return n
    }, e.prototype.getSlick = function() {
        return this
    }, e.prototype.getSlideCount = function() {
        var e, i, o, n = this;
        return o = n.options.centerMode === !0 ? n.slideWidth * Math.floor(n.options.slidesToShow / 2) : 0, n.options.swipeToSlide === !0 ? (n.$slideTrack.find(".slick-slide").each(function(e, r) {
            return r.offsetLeft - o + t(r).outerWidth() / 2 > -1 * n.swipeLeft ? (i = r, !1) : void 0
        }), e = Math.abs(t(i).attr("data-slick-index") - n.currentSlide) || 1) : n.options.slidesToScroll
    }, e.prototype.goTo = e.prototype.slickGoTo = function(t, e) {
        var i = this;
        i.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }, e.prototype.init = function(e) {
        var i = this;
        t(i.$slider).hasClass("slick-initialized") || (t(i.$slider).addClass("slick-initialized"), i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), i.updateArrows(), i.updateDots()), e && i.$slider.trigger("init", [i]), i.options.accessibility === !0 && i.initADA()
    }, e.prototype.initArrowEvents = function() {
        var t = this;
        t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.on("click.slick", {
            message: "previous"
        }, t.changeSlide), t.$nextArrow.on("click.slick", {
            message: "next"
        }, t.changeSlide))
    }, e.prototype.initDotEvents = function() {
        var e = this;
        e.options.dots === !0 && e.slideCount > e.options.slidesToShow && t("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.options.autoplay === !0 && t("li", e.$dots).on("mouseenter.slick", t.proxy(e.setPaused, e, !0)).on("mouseleave.slick", t.proxy(e.setPaused, e, !1))
    }, e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), t(document).on(e.visibilityChange, t.proxy(e.visibility, e)), e.$list.on("mouseenter.slick", t.proxy(e.setPaused, e, !0)), e.$list.on("mouseleave.slick", t.proxy(e.setPaused, e, !1)), e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && t(e.$slideTrack).children().on("click.slick", e.selectHandler), t(window).on("orientationchange.slick.slick-" + e.instanceUid, t.proxy(e.orientationChange, e)), t(window).on("resize.slick.slick-" + e.instanceUid, t.proxy(e.resize, e)), t("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
    }, e.prototype.initUI = function() {
        var t = this;
        t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(), t.$nextArrow.show()), t.options.dots === !0 && t.slideCount > t.options.slidesToShow && t.$dots.show(), t.options.autoplay === !0 && t.autoPlay()
    }, e.prototype.keyHandler = function(t) {
        var e = this;
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && e.options.accessibility === !0 ? e.changeSlide({
            data: {
                message: "previous"
            }
        }) : 39 === t.keyCode && e.options.accessibility === !0 && e.changeSlide({
            data: {
                message: "next"
            }
        }))
    }, e.prototype.lazyLoad = function() {
        function e(e) {
            t("img[data-lazy]", e).each(function() {
                var e = t(this),
                    i = t(this).attr("data-lazy"),
                    o = document.createElement("img");
                o.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        e.attr("src", i).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy").removeClass("slick-loading")
                        })
                    })
                }, o.src = i
            })
        }
        var i, o, n, r, s = this;
        s.options.centerMode === !0 ? s.options.infinite === !0 ? (n = s.currentSlide + (s.options.slidesToShow / 2 + 1), r = n + s.options.slidesToShow + 2) : (n = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1)), r = 2 + (s.options.slidesToShow / 2 + 1) + s.currentSlide) : (n = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide, r = n + s.options.slidesToShow, s.options.fade === !0 && (n > 0 && n--, r <= s.slideCount && r++)), i = s.$slider.find(".slick-slide").slice(n, r), e(i), s.slideCount <= s.options.slidesToShow ? (o = s.$slider.find(".slick-slide"), e(o)) : s.currentSlide >= s.slideCount - s.options.slidesToShow ? (o = s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow), e(o)) : 0 === s.currentSlide && (o = s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow), e(o))
    }, e.prototype.loadSlider = function() {
        var t = this;
        t.setPosition(), t.$slideTrack.css({
            opacity: 1
        }), t.$slider.removeClass("slick-loading"), t.initUI(), "progressive" === t.options.lazyLoad && t.progressiveLazyLoad()
    }, e.prototype.next = e.prototype.slickNext = function() {
        var t = this;
        t.changeSlide({
            data: {
                message: "next"
            }
        })
    }, e.prototype.orientationChange = function() {
        var t = this;
        t.checkResponsive(), t.setPosition()
    }, e.prototype.pause = e.prototype.slickPause = function() {
        var t = this;
        t.autoPlayClear(), t.paused = !0
    }, e.prototype.play = e.prototype.slickPlay = function() {
        var t = this;
        t.paused = !1, t.autoPlay()
    }, e.prototype.postSlide = function(t) {
        var e = this;
        e.$slider.trigger("afterChange", [e, t]), e.animating = !1, e.setPosition(), e.swipeLeft = null, e.options.autoplay === !0 && e.paused === !1 && e.autoPlay(), e.options.accessibility === !0 && e.initADA()
    }, e.prototype.prev = e.prototype.slickPrev = function() {
        var t = this;
        t.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, e.prototype.preventDefault = function(t) {
        t.preventDefault()
    }, e.prototype.progressiveLazyLoad = function() {
        var e, i, o = this;
        e = t("img[data-lazy]", o.$slider).length, e > 0 && (i = t("img[data-lazy]", o.$slider).first(), i.attr("src", i.attr("data-lazy")).removeClass("slick-loading").load(function() {
            i.removeAttr("data-lazy"), o.progressiveLazyLoad(), o.options.adaptiveHeight === !0 && o.setPosition()
        }).error(function() {
            i.removeAttr("data-lazy"), o.progressiveLazyLoad()
        }))
    }, e.prototype.refresh = function(e) {
        var i = this,
            o = i.currentSlide;
        i.destroy(!0), t.extend(i, i.initials, {
            currentSlide: o
        }), i.init(), e || i.changeSlide({
            data: {
                message: "index",
                index: o
            }
        }, !1)
    }, e.prototype.registerBreakpoints = function() {
        var e, i, o, n = this,
            r = n.options.responsive || null;
        if ("array" === t.type(r) && r.length) {
            n.respondTo = n.options.respondTo || "window";
            for (e in r)
                if (o = n.breakpoints.length - 1, i = r[e].breakpoint, r.hasOwnProperty(e)) {
                    for (; o >= 0;) n.breakpoints[o] && n.breakpoints[o] === i && n.breakpoints.splice(o, 1), o--;
                    n.breakpoints.push(i), n.breakpointSettings[i] = r[e].settings
                }
            n.breakpoints.sort(function(t, e) {
                return n.options.mobileFirst ? t - e : e - t
            })
        }
    }, e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && t(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses(0), e.setPosition(), e.$slider.trigger("reInit", [e]), e.options.autoplay === !0 && e.focusHandler()
    }, e.prototype.resize = function() {
        var e = this;
        t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, e.prototype.removeSlide = e.prototype.slickRemove = function(t, e, i) {
        var o = this;
        return "boolean" == typeof t ? (e = t, t = e === !0 ? 0 : o.slideCount - 1) : t = e === !0 ? --t : t, o.slideCount < 1 || 0 > t || t > o.slideCount - 1 ? !1 : (o.unload(), i === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(t).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit())
    }, e.prototype.setCSS = function(t) {
        var e, i, o = this,
            n = {};
        o.options.rtl === !0 && (t = -t), e = "left" == o.positionProp ? Math.ceil(t) + "px" : "0px", i = "top" == o.positionProp ? Math.ceil(t) + "px" : "0px", n[o.positionProp] = t, o.transformsEnabled === !1 ? o.$slideTrack.css(n) : (n = {}, o.cssTransitions === !1 ? (n[o.animType] = "translate(" + e + ", " + i + ")", o.$slideTrack.css(n)) : (n[o.animType] = "translate3d(" + e + ", " + i + ", 0px)", o.$slideTrack.css(n)))
    }, e.prototype.setDimensions = function() {
        var t = this;
        t.options.vertical === !1 ? t.options.centerMode === !0 && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), t.options.centerMode === !0 && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), t.options.vertical === !1 && t.options.variableWidth === !1 ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : t.options.variableWidth === !0 ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        t.options.variableWidth === !1 && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }, e.prototype.setFade = function() {
        var e, i = this;
        i.$slides.each(function(o, n) {
            e = i.slideWidth * o * -1, t(n).css(i.options.rtl === !0 ? {
                position: "relative",
                right: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            } : {
                position: "relative",
                left: e,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            })
        }), i.$slides.eq(i.currentSlide).css({
            zIndex: i.options.zIndex - 1,
            opacity: 1
        })
    }, e.prototype.setHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && t.options.adaptiveHeight === !0 && t.options.vertical === !1) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.css("height", e)
        }
    }, e.prototype.setOption = e.prototype.slickSetOption = function(e, i, o) {
        var n, r, s = this;
        if ("responsive" === e && "array" === t.type(i))
            for (r in i)
                if ("array" !== t.type(s.options.responsive)) s.options.responsive = [i[r]];
                else {
                    for (n = s.options.responsive.length - 1; n >= 0;) s.options.responsive[n].breakpoint === i[r].breakpoint && s.options.responsive.splice(n, 1), n--;
                    s.options.responsive.push(i[r])
                } else s.options[e] = i;
        o === !0 && (s.unload(), s.reinit())
    }, e.prototype.setPosition = function() {
        var t = this;
        t.setDimensions(), t.setHeight(), t.options.fade === !1 ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(), t.$slider.trigger("setPosition", [t])
    }, e.prototype.setProps = function() {
        var t = this,
            e = document.body.style;
        t.positionProp = t.options.vertical === !0 ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && t.options.useCSS === !0 && (t.cssTransitions = !0), t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), void 0 !== e.transform && t.animType !== !1 && (t.animType = "transform", t.transformType = "transform", t.transitionType = "transition"), t.transformsEnabled = null !== t.animType && t.animType !== !1
    }, e.prototype.setSlideClasses = function(t) {
        var e, i, o, n, r = this;
        i = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), r.$slides.eq(t).addClass("slick-current"), r.options.centerMode === !0 ? (e = Math.floor(r.options.slidesToShow / 2), r.options.infinite === !0 && (t >= e && t <= r.slideCount - 1 - e ? r.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = r.options.slidesToShow + t, i.slice(o - e + 1, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === t ? i.eq(i.length - 1 - r.options.slidesToShow).addClass("slick-center") : t === r.slideCount - 1 && i.eq(r.options.slidesToShow).addClass("slick-center")), r.$slides.eq(t).addClass("slick-center")) : t >= 0 && t <= r.slideCount - r.options.slidesToShow ? r.$slides.slice(t, t + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= r.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (n = r.slideCount % r.options.slidesToShow, o = r.options.infinite === !0 ? r.options.slidesToShow + t : t, r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - t < r.options.slidesToShow ? i.slice(o - (r.options.slidesToShow - n), o + n).addClass("slick-active").attr("aria-hidden", "false") : i.slice(o, o + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === r.options.lazyLoad && r.lazyLoad()
    }, e.prototype.setupInfinite = function() {
        var e, i, o, n = this;
        if (n.options.fade === !0 && (n.options.centerMode = !1), n.options.infinite === !0 && n.options.fade === !1 && (i = null, n.slideCount > n.options.slidesToShow)) {
            for (o = n.options.centerMode === !0 ? n.options.slidesToShow + 1 : n.options.slidesToShow, e = n.slideCount; e > n.slideCount - o; e -= 1) i = e - 1, t(n.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - n.slideCount).prependTo(n.$slideTrack).addClass("slick-cloned");
            for (e = 0; o > e; e += 1) i = e, t(n.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + n.slideCount).appendTo(n.$slideTrack).addClass("slick-cloned");
            n.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                t(this).attr("id", "")
            })
        }
    }, e.prototype.setPaused = function(t) {
        var e = this;
        e.options.autoplay === !0 && e.options.pauseOnHover === !0 && (e.paused = t, t ? e.autoPlayClear() : e.autoPlay())
    }, e.prototype.selectHandler = function(e) {
        var i = this,
            o = t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide"),
            n = parseInt(o.attr("data-slick-index"));
        return n || (n = 0), i.slideCount <= i.options.slidesToShow ? (i.setSlideClasses(n), void i.asNavFor(n)) : void i.slideHandler(n)
    }, e.prototype.slideHandler = function(t, e, i) {
        var o, n, r, s, a = null,
            l = this;
        return e = e || !1, l.animating === !0 && l.options.waitForAnimate === !0 || l.options.fade === !0 && l.currentSlide === t || l.slideCount <= l.options.slidesToShow ? void 0 : (e === !1 && l.asNavFor(t), o = t, a = l.getLeft(o), s = l.getLeft(l.currentSlide), l.currentLeft = null === l.swipeLeft ? s : l.swipeLeft, l.options.infinite === !1 && l.options.centerMode === !1 && (0 > t || t > l.getDotCount() * l.options.slidesToScroll) ? void(l.options.fade === !1 && (o = l.currentSlide, i !== !0 ? l.animateSlide(s, function() {
            l.postSlide(o)
        }) : l.postSlide(o))) : l.options.infinite === !1 && l.options.centerMode === !0 && (0 > t || t > l.slideCount - l.options.slidesToScroll) ? void(l.options.fade === !1 && (o = l.currentSlide, i !== !0 ? l.animateSlide(s, function() {
            l.postSlide(o)
        }) : l.postSlide(o))) : (l.options.autoplay === !0 && clearInterval(l.autoPlayTimer), n = 0 > o ? l.slideCount % l.options.slidesToScroll !== 0 ? l.slideCount - l.slideCount % l.options.slidesToScroll : l.slideCount + o : o >= l.slideCount ? l.slideCount % l.options.slidesToScroll !== 0 ? 0 : o - l.slideCount : o, l.animating = !0, l.$slider.trigger("beforeChange", [l, l.currentSlide, n]), r = l.currentSlide, l.currentSlide = n, l.setSlideClasses(l.currentSlide), l.updateDots(), l.updateArrows(), l.options.fade === !0 ? (i !== !0 ? (l.fadeSlideOut(r), l.fadeSlide(n, function() {
            l.postSlide(n)
        })) : l.postSlide(n), void l.animateHeight()) : void(i !== !0 ? l.animateSlide(a, function() {
            l.postSlide(n)
        }) : l.postSlide(n))))
    }, e.prototype.startLoad = function() {
        var t = this;
        t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(), t.$nextArrow.hide()), t.options.dots === !0 && t.slideCount > t.options.slidesToShow && t.$dots.hide(), t.$slider.addClass("slick-loading")
    }, e.prototype.swipeDirection = function() {
        var t, e, i, o, n = this;
        return t = n.touchObject.startX - n.touchObject.curX, e = n.touchObject.startY - n.touchObject.curY, i = Math.atan2(e, t), o = Math.round(180 * i / Math.PI), 0 > o && (o = 360 - Math.abs(o)), 45 >= o && o >= 0 ? n.options.rtl === !1 ? "left" : "right" : 360 >= o && o >= 315 ? n.options.rtl === !1 ? "left" : "right" : o >= 135 && 225 >= o ? n.options.rtl === !1 ? "right" : "left" : n.options.verticalSwiping === !0 ? o >= 35 && 135 >= o ? "left" : "right" : "vertical"
    }, e.prototype.swipeEnd = function(t) {
        var e, i = this;
        if (i.dragging = !1, i.shouldClick = i.touchObject.swipeLength > 10 ? !1 : !0, void 0 === i.touchObject.curX) return !1;
        if (i.touchObject.edgeHit === !0 && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) switch (i.swipeDirection()) {
            case "left":
                e = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.slideHandler(e), i.currentDirection = 0, i.touchObject = {}, i.$slider.trigger("swipe", [i, "left"]);
                break;
            case "right":
                e = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.slideHandler(e), i.currentDirection = 1, i.touchObject = {}, i.$slider.trigger("swipe", [i, "right"])
        } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
    }, e.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(e.options.swipe === !1 || "ontouchend" in document && e.options.swipe === !1 || e.options.draggable === !1 && -1 !== t.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
        }
    }, e.prototype.swipeMove = function(t) {
        var e, i, o, n, r, s = this;
        return r = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !s.dragging || r && 1 !== r.length ? !1 : (e = s.getLeft(s.currentSlide), s.touchObject.curX = void 0 !== r ? r[0].pageX : t.clientX, s.touchObject.curY = void 0 !== r ? r[0].pageY : t.clientY, s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))), s.options.verticalSwiping === !0 && (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2)))), i = s.swipeDirection(), "vertical" !== i ? (void 0 !== t.originalEvent && s.touchObject.swipeLength > 4 && t.preventDefault(), n = (s.options.rtl === !1 ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1), s.options.verticalSwiping === !0 && (n = s.touchObject.curY > s.touchObject.startY ? 1 : -1), o = s.touchObject.swipeLength, s.touchObject.edgeHit = !1, s.options.infinite === !1 && (0 === s.currentSlide && "right" === i || s.currentSlide >= s.getDotCount() && "left" === i) && (o = s.touchObject.swipeLength * s.options.edgeFriction, s.touchObject.edgeHit = !0), s.swipeLeft = s.options.vertical === !1 ? e + o * n : e + o * (s.$list.height() / s.listWidth) * n, s.options.verticalSwiping === !0 && (s.swipeLeft = e + o * n), s.options.fade === !0 || s.options.touchMove === !1 ? !1 : s.animating === !0 ? (s.swipeLeft = null, !1) : void s.setCSS(s.swipeLeft)) : void 0)
    }, e.prototype.swipeStart = function(t) {
        var e, i = this;
        return 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? (i.touchObject = {}, !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, void(i.dragging = !0))
    }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var t = this;
        null !== t.$slidesCache && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.appendTo(t.$slideTrack), t.reinit())
    }, e.prototype.unload = function() {
        var e = this;
        t(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, e.prototype.unslick = function(t) {
        var e = this;
        e.$slider.trigger("unslick", [e, t]), e.destroy()
    }, e.prototype.updateArrows = function() {
        var t, e = this;
        t = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, e.prototype.updateDots = function() {
        var t = this;
        null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }, e.prototype.visibility = function() {
        var t = this;
        document[t.hidden] ? (t.paused = !0, t.autoPlayClear()) : t.options.autoplay === !0 && (t.paused = !1, t.autoPlay())
    }, e.prototype.initADA = function() {
        var e = this;
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(i) {
            t(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + e.instanceUid + i
            })
        }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(i) {
            t(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + i,
                id: "slick-slide" + e.instanceUid + i
            })
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), e.activateADA()
    }, e.prototype.activateADA = function() {
        var t = this,
            e = t.$slider.find("*").is(":focus");
        t.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false",
            tabindex: "0"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        }), e && t.$slideTrack.find(".slick-active").focus()
    }, e.prototype.focusHandler = function() {
        var e = this;
        e.$slider.on("focus.slick blur.slick", "*", function(i) {
            i.stopImmediatePropagation();
            var o = t(this);
            setTimeout(function() {
                e.isPlay && (o.is(":focus") ? (e.autoPlayClear(), e.paused = !0) : (e.paused = !1, e.autoPlay()))
            }, 0)
        })
    }, t.fn.slick = function() {
        var t, i = this,
            o = arguments[0],
            n = Array.prototype.slice.call(arguments, 1),
            r = i.length,
            s = 0;
        for (s; r > s; s++)
            if ("object" == typeof o || "undefined" == typeof o ? i[s].slick = new e(i[s], o) : t = i[s].slick[o].apply(i[s].slick, n), "undefined" != typeof t) return t;
        return i
    }
}),
function(t, e) {
    function i() {
        T = E = S = $ = x = I = j
    }

    function o(t, e) {
        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
    }

    function n(t) {
        return parseFloat(t) || 0
    }

    function r() {
        L = {
            top: e.pageYOffset,
            left: e.pageXOffset
        }
    }

    function s() {
        return e.pageXOffset != L.left ? (r(), void S()) : void(e.pageYOffset != L.top && (r(), l()))
    }

    function a(t) {
        setTimeout(function() {
            e.pageYOffset != L.top && (L.top = e.pageYOffset, l())
        }, 0)
    }

    function l() {
        for (var t = M.length - 1; t >= 0; t--) c(M[t])
    }

    function c(t) {
        if (t.inited) {
            var e = L.top <= t.limit.start ? 0 : L.top >= t.limit.end ? 2 : 1;
            t.mode != e && f(t, e)
        }
    }

    function u() {
        for (var t = M.length - 1; t >= 0; t--)
            if (M[t].inited) {
                var e = Math.abs(w(M[t].clone) - M[t].docOffsetTop),
                    i = Math.abs(M[t].parent.node.offsetHeight - M[t].parent.height);
                if (e >= 2 || i >= 2) return !1
            }
        return !0
    }

    function d(t) {
        isNaN(parseFloat(t.computed.top)) || t.isCell || (t.inited = !0, t.clone || y(t), "absolute" != t.parent.computed.position && "relative" != t.parent.computed.position && (t.parent.node.style.position = "relative"), c(t), t.parent.height = t.parent.node.offsetHeight, t.docOffsetTop = w(t.clone))
    }

    function p(t) {
        var e = !0;
        t.clone && g(t), o(t.node.style, t.css);
        for (var i = M.length - 1; i >= 0; i--)
            if (M[i].node !== t.node && M[i].parent.node === t.parent.node) {
                e = !1;
                break
            }
        e && (t.parent.node.style.position = t.parent.css.position), t.mode = -1
    }

    function h() {
        for (var t = M.length - 1; t >= 0; t--) d(M[t])
    }

    function m() {
        for (var t = M.length - 1; t >= 0; t--) p(M[t])
    }

    function f(t, e) {
        var i = t.node.style;
        switch (e) {
            case 0:
                i.position = "absolute", i.left = t.offset.left + "px", i.right = t.offset.right + "px", i.top = t.offset.top + "px", i.bottom = "auto", i.width = "auto", i.marginLeft = 0, i.marginRight = 0, i.marginTop = 0;
                break;
            case 1:
                i.position = "fixed", i.left = t.box.left + "px", i.right = t.box.right + "px", i.top = t.css.top, i.bottom = "auto", i.width = "auto", i.marginLeft = 0, i.marginRight = 0, i.marginTop = 0;
                break;
            case 2:
                i.position = "absolute", i.left = t.offset.left + "px", i.right = t.offset.right + "px", i.top = "auto", i.bottom = 0, i.width = "auto", i.marginLeft = 0, i.marginRight = 0
        }
        t.mode = e
    }

    function y(t) {
        t.clone = document.createElement("div");
        var e = t.node.nextSibling || t.node,
            i = t.clone.style;
        i.height = t.height + "px", i.width = t.width + "px", i.marginTop = t.computed.marginTop, i.marginBottom = t.computed.marginBottom, i.marginLeft = t.computed.marginLeft, i.marginRight = t.computed.marginRight, i.padding = i.border = i.borderSpacing = 0, i.fontSize = "1em", i.position = "static", i.cssFloat = t.computed.cssFloat, t.node.parentNode.insertBefore(t.clone, e)
    }

    function g(t) {
        t.clone.parentNode.removeChild(t.clone), t.clone = void 0
    }

    function v(t) {
        var e = getComputedStyle(t),
            i = t.parentNode,
            o = getComputedStyle(i),
            r = t.style.position;
        t.style.position = "relative";
        var s = {
                top: e.top,
                marginTop: e.marginTop,
                marginBottom: e.marginBottom,
                marginLeft: e.marginLeft,
                marginRight: e.marginRight,
                cssFloat: e.cssFloat
            },
            a = {
                top: n(e.top),
                marginBottom: n(e.marginBottom),
                paddingLeft: n(e.paddingLeft),
                paddingRight: n(e.paddingRight),
                borderLeftWidth: n(e.borderLeftWidth),
                borderRightWidth: n(e.borderRightWidth)
            };
        t.style.position = r;
        var l = {
                position: t.style.position,
                top: t.style.top,
                bottom: t.style.bottom,
                left: t.style.left,
                right: t.style.right,
                width: t.style.width,
                marginTop: t.style.marginTop,
                marginLeft: t.style.marginLeft,
                marginRight: t.style.marginRight
            },
            c = _(t),
            u = _(i),
            d = {
                node: i,
                css: {
                    position: i.style.position
                },
                computed: {
                    position: o.position
                },
                numeric: {
                    borderLeftWidth: n(o.borderLeftWidth),
                    borderRightWidth: n(o.borderRightWidth),
                    borderTopWidth: n(o.borderTopWidth),
                    borderBottomWidth: n(o.borderBottomWidth)
                }
            },
            p = {
                node: t,
                box: {
                    left: c.win.left,
                    right: O.clientWidth - c.win.right
                },
                offset: {
                    top: c.win.top - u.win.top - d.numeric.borderTopWidth,
                    left: c.win.left - u.win.left - d.numeric.borderLeftWidth,
                    right: -c.win.right + u.win.right - d.numeric.borderRightWidth
                },
                css: l,
                isCell: "table-cell" == e.display,
                computed: s,
                numeric: a,
                width: c.win.right - c.win.left,
                height: c.win.bottom - c.win.top,
                mode: -1,
                inited: !1,
                parent: d,
                limit: {
                    start: c.doc.top - a.top,
                    end: u.doc.top + i.offsetHeight - d.numeric.borderBottomWidth - t.offsetHeight - a.top - a.marginBottom
                }
            };
        return p
    }

    function w(t) {
        for (var e = 0; t;) e += t.offsetTop, t = t.offsetParent;
        return e
    }

    function _(t) {
        var i = t.getBoundingClientRect();
        return {
            doc: {
                top: i.top + e.pageYOffset,
                left: i.left + e.pageXOffset
            },
            win: i
        }
    }

    function b() {
        P = setInterval(function() {
            !u() && S()
        }, 500)
    }

    function k() {
        clearInterval(P)
    }

    function C() {
        D && (document[R] ? k() : b())
    }

    function T() {
        D || (r(), h(), e.addEventListener("scroll", s), e.addEventListener("wheel", a), e.addEventListener("resize", S), e.addEventListener("orientationchange", S), t.addEventListener(N, C), b(), D = !0)
    }

    function S() {
        if (D) {
            m();
            for (var t = M.length - 1; t >= 0; t--) M[t] = v(M[t].node);
            h()
        }
    }

    function $() {
        e.removeEventListener("scroll", s), e.removeEventListener("wheel", a), e.removeEventListener("resize", S), e.removeEventListener("orientationchange", S), t.removeEventListener(N, C), k(), D = !1
    }

    function x() {
        $(), m()
    }

    function I() {
        for (x(); M.length;) M.pop()
    }

    function E(t) {
        for (var e = M.length - 1; e >= 0; e--)
            if (M[e].node === t) return;
        var i = v(t);
        M.push(i), D ? d(i) : T()
    }

    function A(t) {
        for (var e = M.length - 1; e >= 0; e--) M[e].node === t && (p(M[e]), M.splice(e, 1))
    }
    var L, P, M = [],
        D = !1,
        O = t.documentElement,
        j = function() {},
        R = "hidden",
        N = "visibilitychange";
    void 0 !== t.webkitHidden && (R = "webkitHidden", N = "webkitvisibilitychange"), e.getComputedStyle || i();
    for (var B = ["", "-webkit-", "-moz-", "-ms-"], H = document.createElement("div"), z = B.length - 1; z >= 0; z--) {
        try {
            H.style.position = B[z] + "sticky"
        } catch (U) {}
        "" != H.style.position && i()
    }
    r(), e.Stickyfill = {
        stickies: M,
        add: E,
        remove: A,
        init: T,
        rebuild: S,
        pause: $,
        stop: x,
        kill: I
    }
}(document, window), window.jQuery && ! function(t) {
        t.fn.Stickyfill = function(t) {
            return this.each(function() {
                Stickyfill.add(this)
            }), this
        }
    }(window.jQuery),
    function(t) {
        var e = {
            url: !1,
            callback: !1,
            target: !1,
            duration: 120,
            on: "mouseover",
            touch: !0,
            onZoomIn: !1,
            onZoomOut: !1,
            magnify: 1
        };
        t.zoom = function(e, i, o, n) {
            var r, s, a, l, c, u, d, p = t(e).css("position"),
                h = t(i);
            return e.style.position = /(absolute|fixed)/.test(p) ? p : "relative", e.style.overflow = "hidden", o.style.width = o.style.height = "", t(o).addClass("zoomImg").css({
                position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: o.width * n,
                height: o.height * n,
                border: "none",
                maxWidth: "none",
                maxHeight: "none"
            }).appendTo(e), {
                init: function() {
                    s = t(e).outerWidth(), r = t(e).outerHeight(), i === e ? (l = s, a = r) : (l = h.outerWidth(), a = h.outerHeight()), c = (o.width - s) / l, u = (o.height - r) / a, d = h.offset()
                },
                move: function(t) {
                    var e = t.pageX - d.left,
                        i = t.pageY - d.top;
                    i = Math.max(Math.min(i, a), 0), e = Math.max(Math.min(e, l), 0), o.style.left = e * -c + "px", o.style.top = i * -u + "px"
                }
            }
        }, t.fn.zoom = function(i) {
            return this.each(function() {
                var o, n = t.extend({}, e, i || {}),
                    r = n.target || this,
                    s = this,
                    a = t(s),
                    l = document.createElement("img"),
                    c = t(l),
                    u = "mousemove.zoom",
                    d = !1,
                    p = !1;
                (n.url || (o = a.find("img"), o[0] && (n.url = o.data("src") || o.attr("src")), n.url)) && (! function() {
                    var t = r.style.position,
                        e = r.style.overflow;
                    a.one("zoom.destroy", function() {
                        a.off(".zoom"), r.style.position = t, r.style.overflow = e, c.remove()
                    })
                }(), l.onload = function() {
                    function e(e) {
                        o.init(), o.move(e), c.stop().fadeTo(t.support.opacity ? n.duration : 0, 1, t.isFunction(n.onZoomIn) ? n.onZoomIn.call(l) : !1), t(r).addClass("zooming")
                    }

                    function i() {
                        c.stop().fadeTo(n.duration, 0, t.isFunction(n.onZoomOut) ? n.onZoomOut.call(l) : !1), t(r).removeClass("zooming")
                    }
                    var o = t.zoom(r, s, l, n.magnify);
                    "grab" === n.on ? a.on("mousedown.zoom", function(n) {
                        1 === n.which && (t(document).one("mouseup.zoom", function() {
                            i(), t(document).off(u, o.move)
                        }), e(n), t(document).on(u, o.move), n.preventDefault())
                    }) : "click" === n.on ? a.on("click.zoom", function(n) {
                        return d ? void 0 : (d = !0, e(n), t(document).on(u, o.move), t(document).one("click.zoom", function() {
                            i(), d = !1, t(document).off(u, o.move)
                        }), !1)
                    }) : "toggle" === n.on ? a.on("click.zoom", function(t) {
                        d ? i() : e(t), d = !d
                    }) : "mouseover" === n.on && (o.init(), a.on("mouseenter.zoom", e).on("mouseleave.zoom", i).on(u, o.move)), n.touch && a.on("touchstart.zoom", function(t) {
                        t.preventDefault(), p ? (p = !1, i()) : (p = !0, e(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]))
                    }).on("touchmove.zoom", function(t) {
                        t.preventDefault(), o.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
                    }), t.isFunction(n.callback) && n.callback.call(l)
                }, l.src = n.url)
            })
        }, t.fn.zoom.defaults = e
    }(window.jQuery);